import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useParams, useLocation, useSearchParams } from "react-router-dom";
import moment from "moment";
import MuiAlert from "@mui/material/Alert";
import {
    PersonOutline,
    CallOutlined,
    Build,
    CheckCircleOutline,
    PendingOutlined,
    ErrorOutline
} from '@mui/icons-material';
import {
    fetchDeleteData,
    fetchData,
    fetchAllData,
    uploadPdf,
    fetchUpdateData,
} from "../../helpers/externapi";
import Snackbar from "@mui/material/Snackbar";
import CardEditForms from "../../Components/CardEditForms";
import SelectNominee from "../../Components/SelectNominee";
import TableContainer from "@mui/material/TableContainer";
import ConfirmationDialogDelete from "../../Components/ConfirmationDialogDelete";
import Paper from "@mui/material/Paper";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faIndianRupeeSign } from "@fortawesome/free-solid-svg-icons";
import { fetchConfigValues, formatDate, formatDate1 } from "../../Commoncomponents/CommonComponents";
import { Table } from "react-bootstrap";
import UserArea from "../UsersAreaAssign/AssignArea";
import { Box, Button, } from "@mui/material";
import Feedback from "react-bootstrap/esm/Feedback";
import { async } from "validate.js";


const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});


export default function CustomerPersonalDetails(props) {
    const [profile, setProfile] = useState(props.data);
    const navigate = useNavigate();
    const [file, setFile] = useState();
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [PolicyCOINumber, setPolicyCOINumber] = useState("");
    const [snackbarMessage, setSnackbarMessage] = useState("");
    const [callResponseOptions, setCallResponseOptions] = useState([]);
    const [activeTab, setActiveTab] = useState("callHistory");
    const [formError, setFormError] = useState({});
    const [isEditing, setIsEditing] = useState(false);
    const [formVisible, setFormVisible] = useState(false);
    const [callHistory, setCallHistory] = useState([]);
    const [cardDetails, setCardDetails] = useState([]);
    const [loading, setLoading] = useState();
    const [products, setProducts] = useState([]);
    const [showNominee, setShowNominee] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [showProductDetailsTab, setShowProductDetailsTab] = useState(false);
    const initialFormData = {
        callHistoryId: "",
        callLog: "",
        CollectedDate: "",
        callResponsesId: "",
        DateToBeVisited: "",
    };
    const [addFormData, setAddFormData] = useState({
        AddressLine1: "",
        AddressLine2: "",
        StateName: "",
        StateId: "",
        DistrictName: "",
        DistrictId: "",
        City: "",
        Pincode: "",
        Village: "",
        Mandal: "",
        UserId: "",
        UserName: "",
        RmId: "",
        Table: "",
    });
    const [formData, setFormData] = useState(initialFormData);
    const [isFormValid, setIsFormValid] = useState(false);
    const [confirmationOpen, setConfirmationOpen] = useState(false);
    const [confirmationData, setConfirmationData] = useState({});
    const [availableProducts, setAvailableProducts] = useState();
    const [memberDetails, setMemberDetails] = useState();
    const [purchaseProduct, setPurchaseProduct] = useState();
    const [utrNumber, setUtrNumber] = useState("");
    const [utrError, setUtrError] = useState(false);
    const [paymentSuccessMsg, setPaymentSeccessMsg] = useState(false);
    const [comboProductDetails, setComboProductDetails] = useState([]);
    const [familyMembersLength, setFamilyMembesLength] = useState();
    const [cardNumberEntered, setCardNumberEntered] = useState(false);
    const [cardNumber, setCardNumber] = useState("2804 00");
    const [cardNumberError, setCardNumberError] = useState(null);
    const [memberPrdAddFail, setMemberProdAddFail] = useState("");
    const [paymentFailureError, setPaymentFailureError] = useState("");
    const [updatePaymentForProductError, setUpdatePaymentForProductError] =
        useState("");
    const [cardAddError, setCardAddError] = useState("");
    const [utrSubmitLoad, setUtrSubmitLoad] = useState(false);
    const [base64, setBase64] = useState(null);
    const [paUrl, setPaUrl] = useState("");
    const [policyUploadLoad, setPolicyUploadLoad] = useState(false);
    const [isFlipped, setIsFlipped] = useState(false);
    const [policies, setPolicies] = useState([]);
    const [selectedPolicy, setSelectedpolicy] = useState();
    const [cardLoading, setCardLoading] = useState(false);
    const [callHistoryLoading, setCallHistoryLoading] = useState(false);
    const [productsLoading, setProductsLoading] = useState(false);
    const [isBookServiceHovered, setIsBookServiceHovered] = useState(false);
    const [gmcLoading, setGmcLoading] = useState(false);
    const [selectedIndividualProduct, setSelectedIndividualProduct] = useState();
    const [showIndividualProducts, setShowIndividualProducts] = useState(false);
    const [cardFrontImage, setCardFrontImage] = useState(null);
    const [cardBackImage, setCardBackImage] = useState(null);
    const [districtDropdown, setDistrictDropdown] = useState([]);
    const [stateDropdown, setStateDropdown] = useState([]);
    const [rmOptions, setRmOptions] = useState([]);
    const [selectedRM, setSelectedRM] = useState(profile?.RMId || "");
    const [isEditingRM, setIsEditingRM] = useState(false);
    const isFetching = useRef(false);
    const [claimedDate, setClaimedDate] = useState([]);
    const [claimDate, setClaimDate] = useState([]);
    const [selectedDistrictId, setSelectedDistrictId] = useState(null);
    const [selectedStateId, setSelectedStateId] = useState(null);
    const [activeSection, setActiveSection] = useState("product");
    const [activeServiceTab, setActiveServiceTab] = useState("claimServices");
    const [activeActivityTab, setActiveActivityTab] = useState("all");
    const UserId = localStorage.getItem("UserId");
    const [selectedActivityId, setSelectedActivityId] = useState(null);
    const [activity, setActivity] = useState([]);
    const { Id } = useParams();
    const [customerData, setCustomerData] = useState(null);
    const location = useLocation();
    const [feedBack, setFeedBack] = useState("");
    const [imageUrl, setImageUrl] = useState('');
    const [members, setMembers] = useState([]);
    const [activeProductsTab, setActiveProductsTab] = useState('all');

    const [requestedCoupons, setRequestedCoupons] = useState([]);
    const [requestedCouponsLoading, setRequestedCouponsLoading] = useState(false);

    const statusConfig = {
        "Confirmed": { color: "#28a745", icon: "check-circle", textColor: "#fff" },
        "Pending": { color: "#ffc107", icon: "clock", textColor: "#212529" },
        "Cancelled": { color: "#dc3545", icon: "times-circle", textColor: "#fff" },
        // Default fallback
        "default": { color: "#6c757d", icon: "info-circle", textColor: "#fff" }
    };
    const statusColors = {
        "Initiated": { text: "#3498db", bg: "#D6EAF8" },   // Blue
        "Requested": { text: "#2ecc71", bg: "#D4EFDF" },  // Green
        "Booked": { text: "#1abc9c", bg: "#D1F2EB" },     // Teal
        "Visited": { text: "#f39c12", bg: "#FDEBD0" },    // Orange
        "Customer Feedback": { text: "#e74c3c", bg: "#FADBD8" }, // Red
        "Hospital Feedback": { text: "#9b59b6", bg: "#EBDEF0" }, // Purple
        "Success": { text: "#27ae60", bg: "#D5F5E3" },   // Dark Green
        "Not Visited": { text: "#34495e", bg: "#D6DBDF" } // Dark Blue-Gray
    };
    useEffect(() => {
        // Check for hash in URL
        if (location.hash === '#services') {
            setActiveSection('services');
        }
    }, [location]);

    const handleSnackbarClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setSnackbarOpen(false);
    };

    useEffect(() => {
        const getPAUrl = async () => {

            const { policiesDownloadURL, CardFront, CardBack, userImagesBucketlink } = await fetchConfigValues();

            setPaUrl(policiesDownloadURL);

            setCardFrontImage(CardFront);
            setCardBackImage(CardBack);

            if (userImagesBucketlink) {
                setImageUrl(userImagesBucketlink);
            }
        };

        getPAUrl();
    }, []);

    useEffect(() => {
        const isFormValid = formData.callResponsesId.length > 0;
        setIsFormValid(isFormValid);
    }, [formData]);

    useEffect(() => {
        const getCallResponse = async () => {
            setLoading(true);
            try {
                const getResponseTypes = await fetchData("CallResponseType/all", {
                    skip: 0,
                    take: 0,
                });

                let CallResponseTypeId = getResponseTypes.filter(
                    (types) => types.ResponseName === "Member"
                );

                const response = await fetchAllData(
                    `CallResponse/GetCallResponsesByResponseType/${CallResponseTypeId[0].CallResponseTypeId}`
                );
                setCallResponseOptions(response);
            } catch (error) {
                console.error("Error fetching call responses:", error);
            } finally {
                setLoading(false);
            }
        };


        const getAvailableProducts = async () => {
            setLoading(true);
            try {
                if (
                    cardDetails &&
                    products &&
                    cardDetails.status &&
                    products.length > 0
                ) {
                    const response = await fetchAllData(
                        `MembersProducts/GetProductForMember/${memberDetails[0].MemberId}`
                    );
                    setAvailableProducts(response);
                } else {
                    const response = await fetchData("Products/all", {
                        skip: 0,
                        take: 0,
                    });

                    let getCombo = [];

                    response &&
                        response.length > 0 &&
                        response.map((each) => {
                            if (each.IsCombo) {
                                getCombo = [...getCombo, each];
                            }
                        });

                    setAvailableProducts(getCombo);
                }
            } catch (error) {
                console.error("Error fetching available products: ", error);
            }
        };

        getAvailableProducts();
        getCallResponse();
    }, [memberDetails, products]);


    useEffect(() => {
        const fetchData = async () => {
            try {
                setCardLoading(true);
                const response = await fetchAllData(
                    `lambdaAPI/OHOCards/GetMemberCardByMemberId/${Id}`
                );
                setCardDetails(response);
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setCardLoading(false);
            }
        };

        fetchData();
    }, [Id]);

    useEffect(() => {
        const fetchMemberData = async () => {
            setLoading(true);
            try {
                const response = await fetchAllData(`lambdaAPI/Customer/GetById/${Id}`);
                setMemberDetails(response);
                setLoading(false);
            } catch (error) {
                console.error("Error fetching data:", error);
                setLoading(false);
            }
        };

        const fetchProductsData = async () => {
            setLoading(true);
            try {
                setProductsLoading(true);
                const response = await fetchAllData(`lambdaAPI/Customer/GetMemberProducts/${Id}`);

                setProducts(response[0].Products);
                setPolicies(response[0].Products[0].Policies);
                setLoading(false);
            } catch (error) {
                console.error("Error fetching data:", error);
                setLoading(false);
            } finally {
                setProductsLoading(false);
            }
        };

        const fetchDependentData = async () => {
            const dependent = await fetchAllData(`lambdaAPI/Customer/GetDependentsByCustomerId/${Id}`);


            if (dependent && dependent.length > 0) {

                const formattedDependent = dependent.map((dep) => ({
                    nominee: dep.IsNominee,
                    name: dep.name,
                    dateOfBirth: dep.dateofBirth,
                    relationship: dep.relationship,
                    guardianName: dep.GuardianName,
                    guardianDateofBirth: dep.GuardianDateofBirth,
                    guardianMobileNumber: dep.GuardianMobileNumber,
                }));
                setMembers(formattedDependent);
            }

        };

        fetchDependentData();
        fetchMemberData();
        fetchProductsData();
    }, [Id]);

    const claimedData = async () => {
        try {
            setLoading(true);
            const response = await fetchData("lambdaAPI/BookingConsultation/PendingAndSuccessConsultationList", {
                CustomerId: Id,
                IsCouponClaimed: true
            });
            setClaimedDate(response);
        } catch (error) {
            console.error("Error fetching claimedData data:", error);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        claimedData();
    }, []);

    // Function to fetch all activities
    const fetchAllActivities = async () => {
        try {
            setLoading(true);
            // Only pass CustomerId without ActivityCategory
            const response = await fetchData("lambdaAPI/BookingConsultationActivity/GetBookingActivityByCustomerId", {
                CustomerId: Id
            });
            setActivity(response);
        } catch (error) {
            console.error("Error fetching all activities:", error);
            setFeedBack(`Error: ${error.message}`);
        } finally {
            setLoading(false);
        }
    };

    // If you need to filter activities client-side instead
    const filterActivities = (type) => {
        return activity.filter(item => item.ActivityCategory === type);
    };

    // Usage example
    useEffect(() => {
        fetchAllActivities();
    }, [Id]);

    // Later in your code, when you need specific types:
    const bookingActivities = filterActivities("Booking");
    const feedbackActivities = filterActivities("feedBack");
    const fetchActivitiesByCategory = async (category) => {
        try {
            setLoading(true);
            // Try using a different parameter format 
            const params = {
                CustomerId: Id
            };

            // Only add ActivityCategory if a category is provided
            if (category) {
                params.ActivityCategory = category;
            }

            const response = await fetchData("lambdaAPI/BookingConsultationActivity/GetBookingActivityByCustomerId", params);
            return response;
        } catch (error) {
            console.error(`Error fetching ${category || "all"} activities:`, error);
            return [];
        } finally {
            setLoading(false);
        }
    };

    // Then use it like this:
    const loadAllData = async () => {
        const allActivities = await fetchActivitiesByCategory();
        setActivity(allActivities);


    };
    // Add Id to dependencies if it can change
    // useEffect(() => {
    //   const getClaimedData = async () => {
    //     console.log("Selected Activity ID:", selectedActivityId);

    //     if (selectedActivityId == null) {
    //       console.log("No Activity ID selected or it is null, resetting activity.");
    //       setActivity([]);
    //       return;
    //     }

    //     try {
    //       setLoading(true);
    //       const response = await fetchData(
    //         `lambdaAPI/BookingConsultation/GetBookingActivityByBookingId`,
    //         { BookingConsultationId: selectedActivityId } // Use selectedActivityId in the payload
    //       );

    //       console.log("API Response:", response);

    //       if (Array.isArray(response)) {
    //         setActivity(
    //           response.map((activity) => ({
    //             ...activity,
    //             id: activity.BookingId,
    //           }))
    //         );
    //       } else {
    //         console.log("Response is not an array:", response);
    //         setActivity([]);
    //       }
    //     } catch (error) {
    //       console.error("Error fetching claimed data:", error);
    //       setActivity([]);
    //     } finally {
    //       setLoading(false);
    //     }
    //   };

    //   getClaimedData();
    // }, [selectedActivityId]);






    // useEffect(() => {
    //   // Check for tab parameter in URL
    //   const tabParam = searchParams.get('tab');

    //   // Check for state passed from navigation
    //   const navigationState = location.state;

    //   // Prioritize URL parameter, then navigation state
    //   if (tabParam === 'services') {
    //     setActiveSection('services');
    //   } else if (navigationState?.focusOnServices) {
    //     setActiveSection('services');
    //   }
    // }, [searchParams, location.state]);
    const handleCardNumberChange = (e) => {
        let input = e.target.value.replace(/\D/g, "").substring(6);
        if (input.length > 6) {
            input = input.slice(0, 6);
        }
        const formattedCardNumber = `2804 00${input.slice(0, 2)} ${input.slice(
            2
        )}`.trim();
        setCardNumber(formattedCardNumber);
    };

    const checkCardNumberExists = async () => {
        try {
            const response = await fetchData("OHOCards/cardNumberExistorNot", {
                cardNumber,
                rmId: UserId,
                memberId: Id,
            });
            if (response.status === true) {
                setCardNumberEntered(true);
                setCardNumberError(null);
            } else {
                setCardNumberError(response.message);
            }
        } catch (error) {
            setCardNumberError(
                "An error occurred while checking the card number. Please try again."
            );
        }
    };

    const handleProductClick = async (product) => {
        // setSelectedProduct((prevProduct) =>
        //     prevProduct && prevProduct.ProductsId === product.ProductsId ? null : product
        // );

        setSelectedProduct(product);

        const details = await fetchAllData(
            `ComboProducts/FetchComboProducts/${product.ProductsId}`
        );
        setComboProductDetails(details);

        const response = await fetchAllData(
            `MemberDependent/GetDependentsByMemberProductId/${Id}/${product.ProductsId}`
        );
        setFamilyMembesLength(response.length);

        const isSameProduct =
            selectedProduct && selectedProduct.ProductsId === product.ProductsId;
        setShowNominee(true);
        // if (isSameProduct) {
        //     setIsEditing(true);
        //     setShowProductDetailsTab(true);
        //     setActiveTab('products');
        // } else {
        setShowProductDetailsTab(true);
        setActiveTab("products");
        // }
    };

    const handleSave = () => {
        if (!selectedRM) return;

        // Call API or function to update RM
        setIsEditing(false);
    };
    const EditAddress = async () => {
        try {
            setLoading(true);

            const addressUpdateData = [
                {
                    columnName: "AddressLine1",
                    columnValue: addFormData.AddressLine1,
                    tableName: "Customer",
                    tableId: Id,
                    UpdatedBy: UserId
                },
                {
                    columnName: "AddressLine2",
                    columnValue: addFormData.AddressLine2,
                    tableName: "Customer",
                    tableId: Id,
                    UpdatedBy: UserId
                },
                {
                    columnName: "StateId",
                    columnValue: addFormData.StateId,
                    tableName: "Customer",
                    tableId: Id,
                    UpdatedBy: UserId
                },
                {
                    columnName: "DistrictId",
                    columnValue: addFormData.DistrictId,
                    tableName: "Customer",
                    tableId: Id,
                    UpdatedBy: UserId
                },
                {
                    columnName: "city",
                    columnValue: addFormData.City,
                    tableName: "Customer",
                    tableId: Id,
                    UpdatedBy: UserId
                },
                {
                    columnName: "Pincode",
                    columnValue: addFormData.Pincode,
                    tableName: "Customer",
                    tableId: Id,
                    UpdatedBy: UserId
                },
                {
                    columnName: "Village",
                    columnValue: addFormData.Village,
                    tableName: "Customer",
                    tableId: Id,
                    UpdatedBy: UserId
                },
                {
                    columnName: "Mandal",
                    columnValue: addFormData.Mandal,
                    tableName: "Customer",
                    tableId: Id,
                    UpdatedBy: UserId
                },
            ];

            const EditData = await fetchUpdateData(
                "lambdaAPI/Update/CommonUpdate",
                addressUpdateData
            );

            if (EditData) {
                alert("Address updated successfully!");
                setIsEditing(false);

                setTimeout(() => {
                    window.location.reload();
                }, 500);

            }

        } catch (error) {
            console.error("Error updating address:", error);
        } finally {
            setLoading(false);
            setIsEditing(false);
        }
    };

    const handleRMUpdate = async () => {
        if (isFetching.current) return;
        isFetching.current = true;

        try {
            setLoading(true);

            // Fetch all RM names to get the UserId of the selected RM
            const usersData = await fetchAllData(`lambdaAPI/Employee/GetRMNames`);
            setRmOptions(
                usersData?.map((user) => ({
                    label: user.UserName,
                    value: user.UserId,
                })) || []
            );

            // Find the UserId of the selected RM
            const selectedUser = usersData?.find((user) => user.UserId === selectedRM);
            const selectedUserId = selectedUser ? selectedUser.UserId : null;



            const updateData = [
                {
                    columnName: "EmployeeId",
                    columnValue: selectedRM,
                    tableName: "Customer",
                    tableId: Id,
                    UpdatedBy: UserId
                },
            ];

            const response = await fetchUpdateData("lambdaAPI/Update/CommonUpdate", updateData);


            if (response) {
                alert("RM updated successfully!");
                setIsEditingRM(false);

                setTimeout(() => {
                    window.location.reload();
                }, 500);

            }
        } catch (error) {
            console.error("Error updating RM:", error);

        } finally {
            setLoading(false);
            isFetching.current = false;
        }
    };

    useEffect(() => {
        const getStateDropdown = async () => {
            try {
                const statesData = await fetchData("States/all", { UserId });


                if (Array.isArray(statesData)) {
                    setStateDropdown(statesData);
                } else {
                    console.error("States data is not an array:", statesData);
                    setStateDropdown([]);
                }
            } catch (error) {
                console.error("Error fetching states:", error);
            }
        };

        if (UserId) getStateDropdown();
    }, [UserId]);

    const getDistricts = async (stateId) => {
        if (!stateId) return;

        try {
            const districtsData = await fetchAllData(`Districts/GetByStateId/${stateId}`);
            setDistrictDropdown(districtsData || []);
        } catch (error) {
            console.error("Error fetching districts:", error);
        }
    };

    const handleStateChange = (e) => {
        const selectedStateId = e.target.value;


        setAddFormData((prevData) => ({
            ...prevData,
            StateId: selectedStateId,
            DistrictId: "", // Reset district when state changes
        }));

        getDistricts(selectedStateId); // Fetch districts for selected state
    };

    const handleDistrictChange = (e) => {
        const districtId = e.target.value;

        setAddFormData((prevData) => ({
            ...prevData,
            DistrictId: districtId,
        }));
    };

    useEffect(() => {
        if (addFormData.StateId) {
            getDistricts(addFormData.StateId); // Load districts when editing
        }
    }, [addFormData.StateId]);

    useEffect(() => {

    }, [districtDropdown]);

    useEffect(() => {

    }, [districtDropdown]);

    const getRegionalManagers = async (rmId = null) => {

        if (isFetching.current) return;
        isFetching.current = true;
        try {
            if (rmId) {
                // Fetch RM by ID (after updating RM)
                const userData = await fetchAllData(`Users/GetRMById?rmId${Id}`);
                setSelectedRM(userData?.UserId)
                setProfile((prev) => ({
                    ...prev,
                    RMName: userData?.UserName || "Not exist", // Update displayed RM name
                }));
            } else {
                // Fetch all RM names
                const usersData = await fetchAllData(`lambdaAPI/Employee/GetRMNames`);
                setRmOptions(
                    usersData?.map((user) => ({
                        label: user.UserName,
                        value: user.UserId,
                    })) || []
                );
            }
        } catch (error) {
            console.error("Error fetching RM data:", error);
        } finally {
            isFetching.current = false;
        }
    };


    const handleDelete = () => {
        setConfirmationData({
            title: "Delete Member",
            message: "Are you sure you want to delete this Member?",
            onConfirm: () => confirmhandleDelete(),
        });
        setConfirmationOpen(true);
    };

    const confirmhandleDelete = async () => {
        try {
            const response = await fetchDeleteData(`lambdaAPI/Customer/delete/${Id}`);
            if (response.status === false) {
                setSnackbarMessage(response.message);
                setSnackbarOpen(true);
                return;
            }
            setSnackbarMessage(`Deleted Successfully`);
            setSnackbarOpen(true);

            setTimeout(() => {
                navigate("/customers/list");
            }, 2000);
        } catch (error) {
            console.error("Error deleting event:", error);
            setSnackbarMessage("Failed to delete. Please try again.");
            setSnackbarOpen(true);
        }
    };

    const fetchCallHistoryData = async () => {
        setLoading(true);
        try {
            setCallHistoryLoading(true);
            const response = await fetchAllData(
                `lambdaAPI/CallHistory/GetAllCallHistoryByCustomerId/${Id}`
            );
            setCallHistory(response);
            setLoading(false);
        } catch (error) {
            console.error("Error fetching data:", error);
            setLoading(false);
        } finally {
            setCallHistoryLoading(false);
        }
    };

    useEffect(() => {
        fetchCallHistoryData();
    }, [Id]);

    const handleAddNewCallLog = () => {
        setFormVisible(true);
        setFormData({
            callHistoryId: "",
            callLog: "",
            CollectedDate: "",
            callResponsesId: "",
            DateToBeVisited: "",
        });
    };

    const handleBackToView = () => {
        setFormVisible(false);
    };

    const formatCardNumber = (cardNumber) => {
        if (!cardNumber) return "";
        const chunks = cardNumber.replace(/\s/g, "").match(/.{1,4}/g);
        return chunks.join(" ");
    };

    const handlePrint = () => {
        // Concatenate the address as needed
        const addAddress = () => {
            let address = "";
            selectedProduct.AddressLine1 &&
                (address = `${address} ${selectedProduct.AddressLine1}`);
            selectedProduct.AddressLine2 &&
                (address = `${address}, ${selectedProduct.AddressLine2}`);
            selectedProduct.Village &&
                (address = `${address}, ${selectedProduct.Village}`);
            selectedProduct.City && (address = `${address}, ${selectedProduct.City}`);
            selectedProduct.Mandal &&
                (address = `${address}, ${selectedProduct.Mandal}`);
            selectedProduct.District &&
                (address = `${address}, ${selectedProduct.District}`);
            selectedProduct.State &&
                (address = `${address}, ${selectedProduct.State}`);
            selectedProduct.pincode &&
                (address = `${address}, ${selectedProduct.pincode}`);
            return address;
        };

        const recipientName = selectedProduct.Name || "Recipient Name";
        const recipientMobile = selectedProduct.MobileNumber || "Mobile Number";

        const fromAddress = `
                OHOINDIA LIFE TECH PVT. LTD<br>
                5th Floor, 1-98/9/4/20,<br>
                Arunodaya Colony, VIP Hills,<br>
                Hi-Tech City, Madhapur,<br>
                Hyderabad, Telangana 500081<br>
                Mobile No. 7671997108
            `;

        const appDetails = `
            <div style="text-align: center; padding: 10px; margin-bottom: 20px;">
                <img src="${process.env.PUBLIC_URL}/assets/applogo.png" height="50" alt="App Logo" /><br>
                <strong>OHOINDIA</strong><br>
                Website:- www.ohoindialife.com<br>
                Contact No:- 7671997108 / 7032107108<br>
                Email:- contact@ohoindialife.com<br>
            </div>
            `;

        const printWindow = window.open("", "", "width=396,height=912");
        printWindow.document.write("<html>");
        printWindow.document.write(`
                        <style>
                            @page {
                                size: 4.125in 9.5in;
                                margin: 0;
                            }
                            body {
                                font-family: Arial, sans-serif;
                                padding: 20px;
                            }
                            .box {
                                border: 1px solid black;
                                padding: 10px;
                                margin-bottom: 20px;
                            }
                            h5 {
                                margin: 0;
                            }
                        </style>
                    `);
        printWindow.document.write("<body>");
        printWindow.document.write(appDetails);
        printWindow.document.write(`
                        <div class="box">
                            <strong>From:</strong><br>
                            ${fromAddress}
                        </div>
                        <div class="box">
                            <strong>To:</strong><br>
                            <h5>${recipientName}</h5>
                            ${addAddress()}<br>
                            <strong>Mobile:</strong> ${recipientMobile}
                        </div>
                    `);
        printWindow.document.write("</body></html>");
        printWindow.document.close();
        printWindow.print();
    };

    const handleUploadChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setFile(file);

            const reader = new FileReader();

            // Event listener for successful file read
            reader.onload = () => {
                if (reader.result) {
                    setBase64(reader.result.toString());
                }
            };

            // Read file as Data URL (Base64)
            reader.readAsDataURL(file);
        }
    };

    const handleFileSubmit = async (e) => {
        e.preventDefault();
        const content = base64.split("base64,");

        const formData = new FormData();
        formData.append("MemberId", Id);
        formData.append("productsId", selectedPolicy.PoliciesProductsId);
        formData.append(
            "individualProductsId",
            selectedPolicy.IndividualProductsId
        );
        formData.append("policyDocument", file);
        formData.append("memberProductId", selectedPolicy.PoliciesMemberProductId);
        formData.append("PolicyCOINumber", PolicyCOINumber);
        formData.append("FileContent", content[1]);

        try {
            setPolicyUploadLoad(true);

            const uploadFile = await uploadPdf(
                "lambdaAPI/Subscription/uploadingPolicyDoc",
                formData
            );
            setSnackbarMessage(uploadFile.message);
            setSnackbarOpen(true);
            setPolicyUploadLoad(false);

            // setTimeout(() => {
            //   window.location.reload();
            // }, 2000);
        } catch (error) {
            console.error("Error uploading file:", error);
        }
    };

    const handleGenerateMembership = async () => {
        try {
            setGmcLoading(true);

            const { policiesDownloadURL } = await fetchConfigValues();

            if (!policiesDownloadURL) {
                console.error("Policies download URL configuration not found.");
                setSnackbarMessage("Unable to download PDF. Configuration missing.");
                setSnackbarOpen(true);
                return;
            }

            const bucketUrl = policiesDownloadURL;

            const response = await fetchData("lambdaAPI/Payment/PolicyGeneration", {
                memberId: Id,
                productsId: selectedProduct.ProductsId,
                MemberProductId: selectedProduct.MemberProductId,
            });

            const { status, message, data } = response || {};

            if (status && data) {
                const downloadUrl = `${bucketUrl}${data}`;

                const link = document.createElement("a");
                link.href = downloadUrl;
                link.download = data;
                link.target = "_blank";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                // Show success message
                setSnackbarMessage("GMC Regenerated Successfully");
                setSnackbarOpen(true);

                // Refresh the page after a short delay to fetch latest data
                //setTimeout(() => {
                //    window.location.reload();
                //}, 1000);

            } else {
                console.error(
                    "File generation failed or data is missing. Status:",
                    status,
                    "Message:",
                    message
                );
                // Show error message in snackbar
                setSnackbarMessage("Failed to regenerate GMC. Please try again.");
                setSnackbarOpen(true);
            }
        } catch (error) {
            console.error("Error downloading membership PDF:", error);
            setSnackbarMessage("An error occurred while trying to regenerate the GMC.");
            setSnackbarOpen(true);
        } finally {
            setGmcLoading(false);
        }
    };

    const onSubmitHandler = async (event) => {
        event.preventDefault();
        setLoading(true);

        try {
            let CallHistoryData;
            const requestData = {
                callLog: formData.callLog,
                CustomerId: Id,
                userId: UserId,
                callResponsesId: formData.callResponsesId,
                DateToBeVisited:
                    formData.DateToBeVisited === "" ? null : formData.DateToBeVisited,
                RequestCallBack:
                    formData.RequestCallBack === "" ? null : formData.RequestCallBack,
            };

            // if (formData.DateToBeVisited) {
            //     requestData.DateToBeVisited = new Date(formData.DateToBeVisited).toISOString();
            // }

            // if (formData.RequestCallBack) {
            //     requestData.RequestCallBack = new Date(formData.RequestCallBack).toISOString();
            // }

            // if (isEditing) {
            //     requestData.callHistoryId = formData.callHistoryId;
            //     CallHistoryData = await fetchUpdateData('CallHistory/update', requestData);
            //     setSnackbarMessage("Call log updated successfully!");
            // } else {
            CallHistoryData = await fetchData("lambdaAPI/CallHistory/add", requestData);
            setSnackbarMessage("New call log added successfully!");
            // }

            setCallHistory(CallHistoryData);
            setSnackbarOpen(true);
            setIsEditing(false);

            await fetchCallHistoryData();
        } catch (error) {
            console.error("Error adding call log:", error);
        } finally {
            setLoading(false);
            setFormVisible(false);
            setFormData(initialFormData);
        }
    };

    const handleEditForm = () => {
        navigate("/customers/new", { state: { profile } });
    };

    const handleResetForm = () => {
        setFormData(initialFormData);
        setFormError({});
    };

    const onChangeHandler = (event) => {
        const { name, value, type, checked } = event.target;
        let updatedFormData = {
            ...formData,
            [name]: type === "checkbox" ? (checked ? value : "") : value,
        };
        let error = "";

        //if (name === 'DateToBeVisited' && value.length === 10) {
        //    const defaultTime = "T00:00:00";
        //    updatedFormData = { ...updatedFormData, DateToBeVisited: `${value}${defaultTime}` };
        //}
        setFormData(updatedFormData);
        setFormError({ ...formError, [name]: error });
    };

    const cardActiveAndDeactive = async () => {
        const memberId = cardDetails.returnData[0].CardPurchasedMemberId;
        const isActivated =
            cardDetails.returnData[0].IsActivated === null
                ? true
                : cardDetails.returnData[0].IsActivated === false
                    ? true
                    : false;

        const updateApi = await fetchData("lambdaAPI/OHOCards/ActivateorDeactivateTheCard", {
            customerId: Id,
            isActivated,
        });

        window.location.reload();
    };

    const handleUpdateActivated = (message) => {
        setConfirmationData({
            title: `${message} Caed`,
            message: `Are you sure you want to ${message} this Card?`,
            onConfirm: () => cardActiveAndDeactive(),
        });
        setConfirmationOpen(true);
    };

    const onChangeUtrNumber = (e) => {
        setUtrNumber(e.target.value);
    };

    const submitUtrForm = async (e) => {
        e.preventDefault();

        if (utrNumber && utrNumber.length >= 10) {
            setUtrError(false);
            setUtrSubmitLoad(true);

            const memberProductPayload = {
                productsId: purchaseProduct.ProductsId,
                memberId: memberDetails[0].MemberId,
                userId: UserId,
            };

            const responseMemberProductAdd = await fetchData(
                "MembersProducts/add",
                memberProductPayload
            );

            if (responseMemberProductAdd && responseMemberProductAdd.length > 0) {
                setMemberProdAddFail("");

                const paymentPayload = {
                    paidAmount: purchaseProduct.SaleAmount,
                    utrNumber: utrNumber,
                    typeofCard: "Privilege",
                    memberProductId: responseMemberProductAdd[0].memberProductId,
                    memberId: memberDetails[0].MemberId,
                };

                const responsePayment = await fetchData(
                    "PaymentDetails/add",
                    paymentPayload
                );

                if (responsePayment && responsePayment.paymentDetailsId) {
                    setPaymentFailureError("");

                    const paymentMemberProductPayload = {
                        productsId: responseMemberProductAdd[0].productsId,
                        memberId: memberDetails[0].MemberId,
                        paymentDetailsId: responsePayment.paymentDetailsId,
                    };

                    const responsePaymentMemberProduct = await fetchData(
                        "PaymentDetails/UpdatePaymentIdInMemberProduct",
                        paymentMemberProductPayload
                    );

                    if (responsePaymentMemberProduct) {
                        setUpdatePaymentForProductError("");

                        const ohoCardPayload = {
                            ohoCardsId: 0,
                            ohoCardNumber: cardNumber,
                            assignedToRM: UserId,
                            assignedToMember: memberDetails[0].MemberId,
                            cardPurchasedMemberId: memberDetails[0].MemberId,
                            productsId: responseMemberProductAdd[0].productsId,
                            userId: UserId,
                        };

                        const responseOhoCard = await fetchData(
                            "OHOCards/add",
                            ohoCardPayload
                        );

                        setPaymentSeccessMsg(true);
                        if (responseOhoCard && responseOhoCard.status) {
                            setCardAddError("");
                            setPaymentSeccessMsg(true);
                            setTimeout(() => {
                                setPurchaseProduct();
                                setPaymentSeccessMsg(false);
                                setUtrNumber("");
                                setUtrError(false);
                                setUtrSubmitLoad(false);
                                window.location.reload();
                            }, 2000);
                        } else {
                            setUtrSubmitLoad(false);
                            setCardAddError(
                                "Sorry, Failed to add card. Please contact Technical team"
                            );
                            console.error("Failed to generate OHO card:", responseOhoCard);
                        }
                    } else {
                        setUtrSubmitLoad(false);
                        setUpdatePaymentForProductError(
                            "Sorry, Failed to update payment for product. Please contact technical team"
                        );
                    }
                } else {
                    setUtrSubmitLoad(false);
                    setPaymentFailureError(
                        "Sorry payment failed. Please contact technical team."
                    );
                }
            } else {
                setUtrSubmitLoad(false);
                setMemberProdAddFail(
                    "Sorry, Failed to add product. Please contact technical team"
                );
            }
        } else {
            setUtrError(true);
        }
    };

    const handleBookService = async (e) => {
        e.preventDefault();
        navigate("/HospitalConsultation/book", {
            state: { memberId: Id },
        });
    };

    const handleSelectPolicy = (data) => {
        setSelectedpolicy(data);
        setFile();
    };

    const showIndividualProductView = () => (
        <div className="my-2">
            <h5 className="text-center text-danger fw-semibold">
                {selectedIndividualProduct.PoliciesProductName}
            </h5>

            <SelectNominee
                comboProductId={selectedIndividualProduct.IndividualProductsId}
                selectedProduct={selectedIndividualProduct}
                customerId={Id}
            />

            <CardEditForms
                selectedProductId={selectedIndividualProduct.IndividualProductsId}
                selectedProduct={selectedIndividualProduct}
            />
        </div>
    );

    const handleCloseModal = () => {
        setSelectedpolicy();
        setFile();
    };

    const handleProductsBack = () => {
        if (showIndividualProducts) {
            setShowIndividualProducts(false);
        } else {
            setActiveTab("");
        }
    };

    const fetchRequestedCoupons = async () => {
        try {
            setRequestedCouponsLoading(true);
            const response = await fetchAllData(`lambdaAPI/RequestedCoupons/GetCustomerCoupons/${Id}`);
            // API returns { status, message, data }
            if (response && response.data) {
                setRequestedCoupons(response.data);
            } else if (Array.isArray(response)) {
                setRequestedCoupons(response);
            } else {
                setRequestedCoupons([]);
            }
        } catch (error) {
            console.error("Error fetching requested coupons:", error);
            setRequestedCoupons([]);
        } finally {
            setRequestedCouponsLoading(false);
        }
    };

    const thresholdDays = 5;

    return (
        <>
            <div className="row justify-content-center mt-2">
                <div className="col-lg-8 col-md-12">
                    <div className="card border-0 rounded-4 overflow-hidden">
                        <div className="position-relative">

                            <div
                                className="bg-gradient-primary w-100"
                                style={{
                                    height: "100px",
                                    background: "linear-gradient(135deg, #4158d0 0%, #c850c0 75%, #ffcc70 100%)"
                                }}
                            ></div>


                            <div className="px-4">
                                <div className="d-flex flex-wrap align-items-end gap-4">

                                    <div className="position-relative mt-n5">
                                        <div className="rounded-circle p-1 bg-white" style={{ width: "150px", height: "150px" }}>
                                            <img
                                                src={
                                                    profile.MemberImage
                                                        ? `${imageUrl}${profile.MemberImage}`
                                                        : profile.Gender && profile.Gender === "Female"
                                                            ? "../../assets/img/womenlogo.jpg"
                                                            : "../../assets/img/menlogo.jpg"
                                                }
                                                className="rounded-circle w-100 h-100"
                                                style={{ objectFit: "cover" }}
                                                alt="User avatar"
                                            />
                                        </div>
                                    </div>


                                    <div className="d-flex flex-column flex-grow-1">
                                        <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                                            <div>
                                                <h2 className="fw-bold mb-1" style={{ color: "#000" }}>
                                                    {profile.Name}
                                                </h2>
                                                <div className="d-flex align-items-center flex-wrap gap-2">
                                                    {profile.Gender && (
                                                        <span className="badge bg-info bg-opacity-10  fw-normal px-3 py-2 rounded-pill">
                                                            <i className="bx bx-user me-1"></i> {profile.Gender}
                                                        </span>
                                                    )}
                                                    {profile.RegisterOn && (
                                                        <span className="badge bg-light text-secondary fw-normal px-3 py-2 rounded-pill">
                                                            <i className="bx bx-calendar me-1"></i>
                                                            Joined {moment(profile.RegisterOn).format("DD MMM YYYY")}
                                                        </span>
                                                    )}
                                                </div>
                                            </div>


                                            <div className="d-flex gap-2 mt-2 mt-md-0">
                                                {/* <button className="btn btn-primary rounded-pill px-3 py-2 d-flex align-items-center gap-2">
                          <i className="bx bx-user-voice fs-5"></i>
                          <span className="d-none d-sm-inline">Contact</span>
                        </button> */}
                                                <button
                                                    className="btn btn-outline-danger rounded-pill px-3 py-2 d-flex align-items-center gap-2"
                                                    onClick={handleDelete}
                                                >
                                                    <i className="bx bx-trash-alt fs-5"></i>
                                                    <span className="d-none d-sm-inline">Delete</span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div className="card-body p-4">
                            <div className="row g-4">

                                <div className="col-md-4">

                                    <h5 className="d-flex align-items-center">
                                        <span className="icon-wrapper d-flex align-items-center justify-content-center rounded-circle bg-primary text-white me-3"
                                            style={{ width: "38px", height: "38px" }}>
                                            <i className="bx bx-phone fs-5"></i>
                                        </span>
                                        Contact Details
                                    </h5>

                                    <ul className="list-unstyled mb-0">
                                        <li className="pb-3">
                                            <div className="d-flex align-items-start">
                                                <i className="bx bx-phone-call text-primary fs-4 me-3 mt-1"></i>
                                                <div>
                                                    <div className="text-muted mb-1">Mobile Number</div>
                                                    {profile.MobileNumber ? (
                                                        <a href={`tel:${profile.MobileNumber}`} className="text-decoration-none fw-semibold fs-5">
                                                            {profile.MobileNumber}
                                                        </a>
                                                    ) : (
                                                        <span className="text-danger fw-semibold">Not Available</span>
                                                    )}
                                                </div>
                                            </div>
                                        </li>
                                        {profile.AlternateMobileNumber ? (
                                            <li className="pb-3">
                                                <div className="d-flex align-items-start">
                                                    <i className="bx bx-phone-call text-primary fs-4 me-3 mt-1"></i>
                                                    <div>
                                                        <div className="text-muted mb-1">Alternate Mobile Number</div>
                                                        {profile.AlternateMobileNumber ? (
                                                            <a href={`tel:${profile.AlternateMobileNumber}`} className="text-decoration-none fw-semibold fs-5">
                                                                {profile.AlternateMobileNumber}
                                                            </a>
                                                        ) : (
                                                            <span className="text-danger fw-semibold">Not Available</span>
                                                        )}
                                                    </div>
                                                </div>
                                            </li>
                                        ) : null}
                                        <li className="pb-3">
                                            <div className="d-flex align-items-start">
                                                <i className="bx bx-envelope text-primary fs-4 me-3 mt-1"></i>
                                                <div>
                                                    <div className="text-muted mb-1">Email Address</div>
                                                    {profile.Email ? (
                                                        <a href={`mailto:${profile.Email}`} className="text-decoration-none fw-semibold text-break">
                                                            {profile.Email}
                                                        </a>
                                                    ) : (
                                                        <span className="text-danger fw-semibold">Not Available</span>
                                                    )}
                                                </div>-
                                            </div>
                                        </li>
                                        <li>
                                            <div className="d-flex align-items-start">
                                                <i className="bx bx-calendar-event text-primary fs-4 me-3 mt-1"></i>
                                                <div>
                                                    <div className="text-muted mb-1">Date of Birth</div>
                                                    {profile.DateofBirth ? (
                                                        <span className="fw-semibold">
                                                            {moment(profile.DateofBirth).format("DD MMM YYYY")}
                                                        </span>
                                                    ) : (
                                                        <span className="text-warning fw-semibold">Not updated</span>
                                                    )}
                                                </div>
                                            </div>
                                        </li>
                                    </ul>

                                </div>

                                {/* Management Information Card */}
                                <div className="col-md-4">

                                    <h5 className="d-flex align-items-center">
                                        <span className="icon-wrapper d-flex align-items-center justify-content-center rounded-circle bg-primary text-white me-3"
                                            style={{ width: "38px", height: "38px" }}>
                                            <i className="bx bx-user-check fs-5"></i>
                                        </span>
                                        Management
                                    </h5>

                                    <div className="position-relative">
                                        <div className="d-flex align-items-start">
                                            <i className="bx bx-id-card text-primary fs-4 me-3 mt-1"></i>
                                            <div className="w-100">
                                                <div className="text-muted mb-1">Regional Manager</div>
                                                <div className="mt-2 d-flex align-items-center">
                                                    {!isEditingRM ? (
                                                        <>
                                                            <span className="fw-semibold fs-5">
                                                                {profile.RMName || <span className="text-danger">Not assigned</span>}
                                                            </span>
                                                            <button
                                                                className="btn btn-link btn-sm text-primary p-0 ms-3"
                                                                onClick={() => {
                                                                    getRegionalManagers();
                                                                    setIsEditingRM(true);
                                                                }}
                                                            >
                                                                <i className="bx bx-edit-alt fs-5"></i>
                                                            </button>
                                                        </>
                                                    ) : (
                                                        <div className="d-flex flex-column w-100 gap-3">
                                                            <select
                                                                className="form-select"
                                                                value={selectedRM}
                                                                onChange={(e) => setSelectedRM(e.target.value)}
                                                            >
                                                                <option value="">Select Regional Manager</option>
                                                                {rmOptions.map((rm) => (
                                                                    <option key={rm.value} value={rm.value}>
                                                                        {rm.label}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                            <div className="d-flex gap-2 mt-2">
                                                                <button className="btn btn-success py-2 px-3 flex-grow-1" onClick={handleRMUpdate}>
                                                                    <i className="bx bx-check me-1"></i> Save
                                                                </button>
                                                                <button className="btn btn-outline-secondary py-2 px-3" onClick={() => setIsEditingRM(false)}>
                                                                    <i className="bx bx-x"></i> Cancel
                                                                </button>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                                {/* Address Information Card */}
                                <div className="col-md-4">

                                    <div className="d-flex align-items-center justify-content-between">
                                        <h5 className="d-flex align-items-center mb-0">
                                            <span className="icon-wrapper d-flex align-items-center justify-content-center rounded-circle bg-primary text-white me-3"
                                                style={{ width: "38px", height: "38px" }}>
                                                <i className="bx bx-map fs-5"></i>
                                            </span>
                                            Address
                                        </h5>

                                        {!isEditing && (
                                            <span
                                                className="text-primary cursor-pointer"
                                                onClick={() => {
                                                    if (!profile) {
                                                        console.error("Profile data is missing or incomplete.");
                                                        return;
                                                    }
                                                    setAddFormData({
                                                        AddressLine1: profile.AddressLine1 ?? "",
                                                        AddressLine2: profile.AddressLine2 ?? "",
                                                        City: profile.City ?? "",
                                                        Pincode: profile.Pincode ?? "",
                                                        Village: profile.Village ?? "",
                                                        Mandal: profile.Mandal ?? "",
                                                        StateId: profile.StateId || "",
                                                        DistrictId: profile.DistrictId || "",
                                                    });
                                                    setIsEditing(true);
                                                }}
                                            >
                                                <i className="bx bx-edit-alt me-1"></i>
                                            </span>
                                        )}
                                    </div>

                                    <div className="address-content p-4 rounded-4">
                                        {profile ? (
                                            profile.completeAddress ? (
                                                <div className="fw-light lh-lg d-flex flex-row align-items-center flex-wrap">
                                                    {profile.completeAddress.split(',').map((line, index, arr) => (
                                                        <React.Fragment key={index}>
                                                            <span className={`${index === 0 ? 'fw-semibold' : ''}`}>
                                                                {line.trim()}
                                                            </span>
                                                            {index < arr.length - 1 && <span>,&nbsp;</span>}
                                                        </React.Fragment>
                                                    ))}
                                                </div>
                                            ) : (
                                                <div className="text-warning d-flex align-items-center">
                                                    <i className="bx bx-error-circle me-2 fs-4"></i>
                                                    Address not available
                                                </div>
                                            )
                                        ) : (
                                            <div className="text-danger d-flex align-items-center">
                                                <i className="bx bx-error-circle me-2 fs-4"></i>
                                                Not available
                                            </div>
                                        )}
                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-lg-4 col-md-12 mt-3 mt-lg-0">
                    <div
                        className="border-0 rounded-4 overflow-hidden h-100"
                        style={{
                            background: "rgba(255, 255, 255, 0.95)",
                            backdropFilter: "blur(20px)",
                            boxShadow: "0 32px 64px rgba(0, 0, 0, 0.12), 0 0 0 1px rgba(255, 255, 255, 0.2)",
                            border: "1px solid rgba(255, 255, 255, 0.18)"
                        }}
                    >
                        {/* Modern Header */}
                        <div
                            className="d-flex align-items-center py-4 px-4"
                            style={{
                                background: "linear-gradient(135deg, rgba(99, 102, 241, 0.1) 0%, rgba(168, 85, 247, 0.1) 100%)",
                                borderBottom: "1px solid rgba(99, 102, 241, 0.1)"
                            }}
                        >
                            <div className="d-flex align-items-center">
                                <div
                                    className="rounded-3 p-2 me-3"
                                    style={{
                                        background: "linear-gradient(135deg, #6366f1 0%, #a855f7 100%)",
                                        boxShadow: "0 8px 16px rgba(99, 102, 241, 0.3)"
                                    }}
                                >
                                    <i className="bi bi-credit-card-2-front-fill text-white" style={{ fontSize: "1.1rem" }}></i>
                                </div>
                                <div>
                                    <h6 className="m-0 fw-bold" style={{ color: "#1f2937", fontSize: "1rem" }}>Card Information</h6>
                                    <small style={{ color: "#6b7280", fontSize: "0.8rem" }}>Manage your Health card</small>
                                </div>
                            </div>
                        </div>

                        {/* Card Body - Loading State */}
                        {cardLoading ? (
                            <div className="d-flex flex-column justify-content-center align-items-center py-5">
                                <div
                                    className="spinner-border mb-3"
                                    role="status"
                                    style={{
                                        color: "#6366f1",
                                        width: "2.5rem",
                                        height: "2.5rem",
                                        borderWidth: "3px"
                                    }}
                                >
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                                <p className="text-muted mb-0" style={{ fontSize: "0.95rem" }}>Retrieving card details...</p>
                                <div
                                    className="progress mt-3"
                                    style={{
                                        width: '220px',
                                        height: '4px',
                                        background: "rgba(99, 102, 241, 0.1)"
                                    }}
                                >
                                    <div
                                        className="progress-bar progress-bar-striped progress-bar-animated"
                                        style={{
                                            background: "linear-gradient(90deg, #6366f1, #a855f7)",
                                            width: '65%'
                                        }}
                                    ></div>
                                </div>
                            </div>
                        ) : cardDetails.status && cardDetails.returnData.length > 0 ? (
                            <div className="p-3">
                                {/* Responsive 3D Credit Card */}
                                <div className="d-flex justify-content-center mb-4">
                                    <div
                                        style={{
                                            width: "100%",
                                            maxWidth: "340px",
                                            aspectRatio: "16/10", // keeps proportion
                                            perspective: "1000px",
                                            padding: "10px" // prevents clipping when zooming
                                        }}
                                        onMouseEnter={() => setIsFlipped(true)}
                                        onMouseLeave={() => setIsFlipped(false)}
                                        className="cursor-pointer"
                                    >
                                        <div
                                            style={{
                                                position: "relative",
                                                width: "100%",
                                                height: "100%",
                                                transition: "transform 0.6s cubic-bezier(0.23, 1, 0.320, 1)",
                                                transformStyle: "preserve-3d",
                                                transform: isFlipped ? "rotateY(180deg)" : "rotateY(0deg)",
                                            }}
                                        >
                                            {/* Front Side */}
                                            <div
                                                style={{
                                                    position: "absolute",
                                                    inset: 0,
                                                    backfaceVisibility: "hidden",
                                                    borderRadius: "16px",
                                                    overflow: "hidden"
                                                }}
                                            >
                                                <img
                                                    src={cardFrontImage}
                                                    alt="Front side"
                                                    className="w-100 h-100"
                                                    style={{
                                                        objectFit: "contain" // keeps full card visible
                                                    }}
                                                />
                                                <div
                                                    className="position-absolute bottom-0 start-0 w-100"
                                                    style={{ padding: "0px 25px" }}
                                                >
                                                    <p
                                                        className="text-white m-0 mb-2"
                                                        style={{
                                                            fontSize: "1rem",
                                                            fontFamily: "monospace",
                                                            letterSpacing: "0.1em",
                                                            textShadow: "1px 1px 3px rgba(0,0,0,0.6)"
                                                        }}
                                                    >
                                                        {formatCardNumber(cardDetails.returnData[0]?.OHOCardnumber)}
                                                    </p>

                                                    {cardDetails.returnData[0].IsActivated === true ? (
                                                        <span
                                                            className="badge d-inline-flex align-items-center"
                                                            style={{
                                                                background: "rgba(34, 197, 94, 0.9)",
                                                                backdropFilter: "blur(10px)",
                                                                padding: "2px 12px",
                                                                borderRadius: "20px",
                                                                fontSize: "0.75rem",
                                                                fontWeight: "500",
                                                                border: "1px solid rgba(255, 255, 255, 0.2)"
                                                            }}
                                                        >
                                                            <i className="bi bi-check-circle-fill me-2"></i> Active
                                                        </span>
                                                    ) : (
                                                        <span
                                                            className="badge d-inline-flex align-items-center"
                                                            style={{
                                                                background: "rgba(239, 68, 68, 0.9)",
                                                                backdropFilter: "blur(10px)",
                                                                padding: "6px 12px",
                                                                borderRadius: "20px",
                                                                fontSize: "0.75rem",
                                                                fontWeight: "500",
                                                                border: "1px solid rgba(255, 255, 255, 0.2)"
                                                            }}
                                                        >
                                                            <i className="bi bi-x-circle-fill me-2"></i> Inactive
                                                        </span>
                                                    )}
                                                </div>
                                            </div>

                                            {/* Back Side */}
                                            <div
                                                style={{
                                                    position: "absolute",
                                                    inset: 0,
                                                    backfaceVisibility: "hidden",
                                                    transform: "rotateY(180deg)",
                                                    borderRadius: "16px",
                                                    overflow: "hidden"
                                                }}
                                            >
                                                <img
                                                    src={cardBackImage}
                                                    alt="Back side"
                                                    className="w-100 h-100"
                                                    style={{
                                                        objectFit: "contain"
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div
                                    className="text-center mb-4"
                                    style={{ color: "#6b7280" }}
                                >
                                    <small className="d-flex align-items-center justify-content-center">
                                        <i className="bi bi-info-circle me-2"></i>
                                        Hover over card to see the reverse side
                                    </small>
                                </div>

                                {/* Modern Action Buttons */}
                                <div className="d-flex justify-content-center gap-2">
                                    {cardDetails.returnData[0].IsActivated === null || cardDetails.returnData[0].IsActivated === false ? (
                                        <button
                                            type="button"
                                            className="btn btn-sm d-flex align-items-center px-3 py-1"
                                            onClick={() => handleUpdateActivated("Activate")}
                                            style={{
                                                background: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
                                                border: "none",
                                                borderRadius: "8px",
                                                color: "white",
                                                fontWeight: "500",
                                                fontSize: "0.8rem",
                                                boxShadow: "0 4px 8px rgba(16, 185, 129, 0.25)",
                                                transition: "all 0.3s ease"
                                            }}
                                            onMouseOver={(e) => e.target.style.transform = "translateY(-2px)"}
                                            onMouseOut={(e) => e.target.style.transform = "translateY(0px)"}
                                        >
                                            <i className="bi bi-check-circle-fill me-1"></i>
                                            Activate
                                        </button>
                                    ) : (
                                        <button
                                            type="button"
                                            className="btn btn-sm d-flex align-items-center px-3 py-1"
                                            onClick={() => handleUpdateActivated("Deactivate")}
                                            style={{
                                                background: "rgba(239, 68, 68, 0.1)",
                                                border: "1px solid #ef4444",
                                                borderRadius: "8px",
                                                color: "#ef4444",
                                                fontWeight: "500",
                                                fontSize: "0.8rem",
                                                transition: "all 0.3s ease"
                                            }}
                                            onMouseOver={(e) => {
                                                e.target.style.background = "#ef4444";
                                                e.target.style.color = "white";
                                            }}
                                            onMouseOut={(e) => {
                                                e.target.style.background = "rgba(239, 68, 68, 0.1)";
                                                e.target.style.color = "#ef4444";
                                            }}
                                        >
                                            <i className="bi bi-x-circle-fill me-1"></i>
                                            Deactivate
                                        </button>
                                    )}

                                    <button
                                        type="button"
                                        className="btn btn-sm d-flex align-items-center px-3 py-1"
                                        onClick={(e) => handleBookService(e)}
                                        style={{
                                            background: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
                                            border: "none",
                                            borderRadius: "8px",
                                            color: "white",
                                            fontWeight: "500",
                                            fontSize: "0.8rem",
                                            boxShadow: "0 4px 8px rgba(240, 147, 251, 0.25)",
                                            transition: "all 0.3s ease"
                                        }}
                                        onMouseOver={(e) => e.target.style.transform = "translateY(-2px)"}
                                        onMouseOut={(e) => e.target.style.transform = "translateY(0px)"}
                                    >
                                        <i className="bi bi-calendar-check-fill me-1"></i>
                                        Book Service
                                    </button>
                                </div>

                            </div>
                        ) : (
                            <div className="d-flex flex-column justify-content-center align-items-center py-5">
                                <div className="text-center mb-3">
                                    <div
                                        className="rounded-circle p-4 d-inline-flex mb-3"
                                        style={{
                                            background: "rgba(239, 68, 68, 0.1)",
                                            color: "#ef4444"
                                        }}
                                    >
                                        <i className="bi bi-exclamation-circle" style={{ fontSize: "2rem" }}></i>
                                    </div>
                                </div>
                                <div
                                    className="fw-bold text-center mb-2"
                                    style={{ color: "#ef4444", fontSize: "1.1rem" }}
                                >
                                    {cardDetails.message || "No Card Information Available"}
                                </div>
                                <p
                                    className="text-center small mb-0"
                                    style={{ color: "#6b7280", maxWidth: "280px" }}
                                >
                                    The customer does not have a card associated with their account.
                                </p>
                            </div>
                        )}
                    </div>
                </div>

            </div>

            {isEditing && (
                <div
                    className="modal fade show d-block"
                    tabIndex="-1"
                    style={{
                        background: "rgba(0, 0, 0, 0.5)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        minHeight: "100vh",
                    }}
                >
                    <div className="modal-dialog modal-lg modal-dialog-centered">
                        <div className="modal-content border-0 shadow-lg rounded-4">

                            {/* Modal Header */}
                            <div className="modal-header bg-gradient-primary text-white px-4 py-3">
                                <h5 className="modal-title fw-semibold">
                                    <i className="bx bx-map-pin me-2"></i>
                                    Update Address
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close btn-close-white"
                                    onClick={() => setIsEditing(false)}
                                ></button>
                            </div>

                            {/* Modal Body */}
                            <div className="modal-body p-4">
                                <div className="row g-3">
                                    <div className="col-md-6">
                                        <label className="form-label small fw-semibold">Address Line 1</label>
                                        <div className="input-group">
                                            <span className="input-group-text bg-light border-0">
                                                <i className="bx bx-home text-primary"></i>
                                            </span>
                                            <input
                                                type="text"
                                                className="form-control border-0 bg-light"
                                                placeholder="Enter address line 1"
                                                value={addFormData.AddressLine1 || ""}
                                                onChange={(e) => setAddFormData({ ...addFormData, AddressLine1: e.target.value })}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <label className="form-label small fw-semibold">Address Line 2</label>
                                        <div className="input-group">
                                            <span className="input-group-text bg-light border-0">
                                                <i className="bx bx-building-house text-primary"></i>
                                            </span>
                                            <input
                                                type="text"
                                                className="form-control border-0 bg-light"
                                                placeholder="Enter address line 2"
                                                value={addFormData.AddressLine2 || ""}
                                                onChange={(e) => setAddFormData({ ...addFormData, AddressLine2: e.target.value })}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <label className="form-label small fw-semibold">Pincode</label>
                                        <div className="input-group">
                                            <span className="input-group-text bg-light border-0">
                                                <i className="bx bx-code-alt text-primary"></i>
                                            </span>
                                            <input
                                                type="text"
                                                className="form-control border-0 bg-light"
                                                placeholder="Enter pincode"
                                                value={addFormData.Pincode || ""}
                                                onChange={(e) => setAddFormData({ ...addFormData, Pincode: e.target.value })}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <label className="form-label small fw-semibold">City</label>
                                        <div className="input-group">
                                            <span className="input-group-text bg-light border-0">
                                                <i className="bx bx-buildings text-primary"></i>
                                            </span>
                                            <input
                                                type="text"
                                                className="form-control border-0 bg-light"
                                                placeholder="Enter city"
                                                value={addFormData.City || ""}
                                                onChange={(e) => setAddFormData({ ...addFormData, City: e.target.value })}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <label className="form-label small fw-semibold">Mandal</label>
                                        <div className="input-group">
                                            <span className="input-group-text bg-light border-0">
                                                <i className="bx bx-buildings text-primary"></i>
                                            </span>
                                            <input
                                                type="text"
                                                className="form-control border-0 bg-light"
                                                placeholder="Enter Mandal"
                                                value={addFormData.Mandal || ""}
                                                onChange={(e) => setAddFormData({ ...addFormData, Mandal: e.target.value })}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <label className="form-label small fw-semibold">Village</label>
                                        <div className="input-group">
                                            <span className="input-group-text bg-light border-0">
                                                <i className="bx bx-buildings text-primary"></i>
                                            </span>
                                            <input
                                                type="text"
                                                className="form-control border-0 bg-light"
                                                placeholder="Enter Village"
                                                value={addFormData.Village || ""}
                                                onChange={(e) => setAddFormData({ ...addFormData, Village: e.target.value })}
                                            />
                                        </div>
                                    </div>


                                    <div className="col-md-6">
                                        <label className="form-label small fw-semibold">State</label>
                                        <div className="input-group">
                                            <span className="input-group-text bg-light border-0">
                                                <i className="bx bx-globe text-primary"></i>
                                            </span>
                                            <select
                                                className="form-select border-0 bg-light"
                                                value={addFormData.StateId}
                                                onChange={handleStateChange}
                                            >
                                                <option value="">Select State</option>
                                                {stateDropdown.map((state) => (
                                                    <option key={state.StateId} value={state.StateId}>
                                                        {state.StateName}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <label className="form-label small fw-semibold">District</label>
                                        <div className="input-group">
                                            <span className="input-group-text bg-light border-0">
                                                <i className="bx bx-map-pin text-primary"></i>
                                            </span>
                                            <select
                                                className="form-select border-0 bg-light"
                                                value={addFormData.DistrictId}
                                                onChange={handleDistrictChange}
                                            >
                                                <option value="">Select District</option>
                                                {districtDropdown.map((district) => (
                                                    <option key={district.DistrictId} value={district.DistrictId}>
                                                        {district.DistrictName}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Modal Footer */}
                            <div className="modal-footer bg-light border-0 d-flex justify-content-between px-4 py-3">
                                <button
                                    className="btn btn-outline-danger rounded-pill px-4"
                                    onClick={() => setIsEditing(false)}
                                >
                                    <i className="bx bx-x-circle"></i> Cancel
                                </button>
                                <button
                                    className="btn btn-primary rounded-pill px-4 d-flex align-items-center gap-2"
                                    onClick={EditAddress}
                                >
                                    <i className="bx bx-save"></i> Save Changes
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            )}
            {/* <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: { xs: 0.5, sm: 1.5 }, // Reduce spacing between buttons
          padding: 1.5, // Reduce padding
          borderRadius: 3,
          justifyContent: { xs: "center", md: "flex-start" }
        }}
      >
        {[
          { id: "product", label: "Member Products", icon: "bi-box-seam" },
          { id: "call", label: "Call History", icon: "bi-telephone" },
          { id: "services", label: "Services", icon: "bi-gear" }
        ]

          .map((item) => (
            <Button
              key={item.id}
              variant={activeSection === item.id ? "contained" : "outlined"}
              onClick={() => setActiveSection(item.id)}
              sx={{
                borderRadius: 5,
                px: { xs: 1.5, sm: 2 },
                py: 0.8,
                fontSize: "0.85rem",
                textTransform: "none",
                transition: "all 0.3s ease",
                backgroundColor: activeSection === item.id ? "primary.main" : "transparent",
                borderColor: activeSection === item.id ? "primary.main" : "divider",
                color: activeSection === item.id ? "white" : "text.primary",
                fontWeight: 500,
                "&:hover": {
                  backgroundColor: activeSection === item.id ? "primary.dark" : "rgba(0, 0, 0, 0.04)",
                  transform: "translateY(-1px)", // Slight hover effect
                  boxShadow: activeSection === item.id ? "0 4px 10px rgba(25, 118, 210, 0.2)" : "0 3px 6px rgba(0, 0, 0, 0.05)"
                }
              }}
              startIcon={
                <i className={item.icon} style={{ fontSize: "0.95rem" }}></i> // Reduce icon size
              }
            >
              {item.label}
            </Button>
          ))}
      </Box> */}
            {/* {activeSection === "call" && ( */}

            {/* )} */}

            {/* {activeSection === "product" && ( */}
            <div className="col-md-12 mb-4 mt-5">
                <div className="card border-0 rounded-4 overflow-hidden" style={{ boxShadow: "0 0.5rem 1.5rem rgba(0,0,0,0.15)" }}>
                    <div className="card-header border-0 py-4" style={{
                        background: "linear-gradient(135deg, #2e7d32 0%, #4caf50 100%)",
                        position: "relative"
                    }}>
                        <div className="d-flex justify-content-between align-items-center">
                            <div className="d-flex align-items-center">
                                {activeTab === "products" && (
                                    <button
                                        className="btn btn-light rounded-circle me-3 d-flex align-items-center justify-content-center"
                                        style={{
                                            width: "45px",
                                            height: "45px",
                                            backgroundColor: "rgba(255,255,255,0.2)",
                                            border: "2px solid rgba(255,255,255,0.3)",
                                            color: "white",
                                            transition: "all 0.3s ease"
                                        }}
                                        onClick={() => handleProductsBack()}
                                        onMouseOver={(e) => {
                                            e.target.style.backgroundColor = "rgba(255,255,255,0.9)";
                                            e.target.style.color = "#2e7d32";
                                            e.target.style.transform = "scale(1.1)";
                                        }}
                                        onMouseOut={(e) => {
                                            e.target.style.backgroundColor = "rgba(255,255,255,0.2)";
                                            e.target.style.color = "white";
                                            e.target.style.transform = "scale(1)";
                                        }}
                                    >
                                        <i className="bi bi-arrow-left fs-5"></i>
                                    </button>
                                )}
                                <div className="d-flex align-items-center">
                                    <div className="rounded-3 p-2 me-3" style={{ backgroundColor: "rgba(255,255,255,0.2)" }}>
                                        <i className="bi bi-box-seam text-white fs-5"></i>
                                    </div>
                                    <div>
                                        <h4 className="text-white mb-0 fw-bold">Member Products</h4>
                                        <p className="text-white mb-0 small" style={{ opacity: "0.8" }}>Manage your product portfolio</p>
                                    </div>
                                </div>
                            </div>

                            {activeTab === "products" && selectedProduct && (
                                <button
                                    className="btn btn-light d-flex align-items-center gap-2 rounded-pill px-4 py-2 shadow-sm"
                                    onClick={handlePrint}
                                    style={{
                                        transition: "all 0.3s ease",
                                        fontWeight: "600"
                                    }}
                                    onMouseOver={(e) => {
                                        e.target.style.transform = "translateY(-2px)";
                                        e.target.style.boxShadow = "0 8px 25px rgba(0,0,0,0.15)";
                                    }}
                                    onMouseOut={(e) => {
                                        e.target.style.transform = "translateY(0)";
                                        e.target.style.boxShadow = "0 0.125rem 0.25rem rgba(0,0,0,0.075)";
                                    }}
                                >
                                    <i className="bi bi-printer text-success"></i>
                                    <span>Print Address</span>
                                </button>
                            )}
                        </div>
                    </div>

                    <div className="card-body" style={{ padding: "2rem" }}>
                        <div className="overflow-auto" style={{ maxHeight: "650px" }}>
                            {showIndividualProducts ? (
                                showIndividualProductView()
                            ) : activeTab === "products" && selectedProduct ? (
                                <div>
                                    <div className="d-flex gap-2 mb-4 flex-wrap mt-2">
                                        {[
                                            { id: 'all', label: 'Overview', icon: 'bi-info-circle' },
                                            { id: 'documents', label: 'Documents', icon: 'bi-file-earmark-text' },
                                            { id: 'members', label: 'Members', icon: 'bi-people' },
                                        ].map((tab) => (
                                            <button
                                                key={tab.id}
                                                className={`btn btn-sm fw-semibold d-flex align-items-center position-relative ${activeProductsTab === tab.id ? 'bg-primary text-white' : 'bg-light text-dark'}`}
                                                style={{
                                                    borderRadius: '20px',
                                                    padding: '8px 16px',
                                                    transition: 'all 0.3s ease',
                                                    border: 'none',
                                                    boxShadow: activeProductsTab === tab.id ? '0 4px 8px rgba(0,128,128,0.2)' : '0 2px 4px rgba(0,0,0,0.05)',
                                                }}
                                                onClick={() => setActiveProductsTab(tab.id)}
                                            >
                                                <i className={`bi ${tab.icon} me-2`}></i>
                                                {tab.label}
                                                {activeProductsTab === tab.id && (
                                                    <span
                                                        className="position-absolute bottom-0 start-50 translate-middle-x bg-white"
                                                        style={{
                                                            width: '20px',
                                                            height: '3px',
                                                            borderRadius: '3px',
                                                            opacity: 0.8,
                                                        }}
                                                    ></span>
                                                )}
                                            </button>
                                        ))}
                                    </div>

                                    <div className="row mb-2">
                                        {activeProductsTab === 'all' && (
                                            <>
                                                <div className="col-lg-4 mb-4 mb-lg-0">
                                                    <div className="card border-0 rounded-4 h-100" style={{ boxShadow: '0 0.25rem 1rem rgba(0,0,0,0.1)' }}>
                                                        <div
                                                            className="card-header py-3"
                                                            style={{
                                                                background: 'linear-gradient(135deg, rgba(76, 175, 80, 0.1) 0%, rgba(46, 125, 50, 0.05) 100%)',
                                                                borderBottom: '2px solid rgba(76, 175, 80, 0.2)',
                                                            }}
                                                        >
                                                            <h6 className="mb-0 fw-bold d-flex align-items-center text-success">
                                                                <i className="bi bi-info-circle me-2"></i>
                                                                Product Details
                                                            </h6>
                                                        </div>
                                                        <div className="card-body" style={{ padding: '1.5rem' }}>
                                                            <div className="mb-4 text-center">
                                                                <div
                                                                    className="rounded-circle d-inline-flex align-items-center justify-content-center mb-3"
                                                                    style={{
                                                                        width: '60px',
                                                                        height: '60px',
                                                                        background: 'linear-gradient(135deg, #2e7d32 0%, #4caf50 100%)',
                                                                        color: 'white',
                                                                    }}
                                                                >
                                                                    <i className="bi bi-box-seam fs-4"></i>
                                                                </div>
                                                                <h5 className="fw-bold text-dark">{selectedProduct.ProductName || 'N/A'}</h5>
                                                            </div>
                                                            <div className="list-group list-group-flush">
                                                                <div className="list-group-item px-0 d-flex justify-content-between align-items-center py-3 border-0">
                                                                    <span className="fw-semibold d-flex align-items-center" style={{ color: '#666' }}>
                                                                        <i className="bi bi-currency-rupee me-2 text-success"></i>Price
                                                                    </span>
                                                                    <span
                                                                        className="badge fs-6 px-3 py-2 rounded-pill"
                                                                        style={{
                                                                            background: 'linear-gradient(135deg, #4caf50 0%, #2e7d32 100%)',
                                                                            color: 'white',
                                                                        }}
                                                                    >
                                                                        <i className="bi bi-currency-rupee"></i>{selectedProduct.PaidAmount || '0'}
                                                                    </span>
                                                                </div>
                                                                <div className="list-group-item px-0 d-flex justify-content-between align-items-center py-3 border-0">
                                                                    <span className="fw-semibold d-flex align-items-center" style={{ color: '#666' }}>
                                                                        <i className="bi bi-credit-card me-2 text-primary"></i>UTR Number
                                                                    </span>
                                                                    {selectedProduct.UTRNumber && selectedProduct.UTRNumber.length > 0 ? (
                                                                        <span className="fw-semibold text-dark">{selectedProduct.UTRNumber}</span>
                                                                    ) : (
                                                                        <span className="badge bg-danger rounded-pill">Not Available</span>
                                                                    )}
                                                                </div>
                                                                {selectedProduct.IssuedOn && selectedProduct.ValidTill && (
                                                                    <div className="list-group-item px-0 d-flex justify-content-between align-items-center py-3 border-0">
                                                                        <span className="fw-semibold d-flex align-items-center" style={{ color: '#666' }}>
                                                                            <i className="bi bi-calendar-check me-2 text-info"></i>Valid Until
                                                                        </span>
                                                                        <span className="fw-semibold text-dark">{formatDate(selectedProduct.ValidTill).slice(0, 11)}</span>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {policies && policies.length > 0 && (
                                                    <div className="col-lg-8">
                                                        <div className="card border-0 rounded-4 h-100" style={{ boxShadow: '0 0.25rem 1rem rgba(0,0,0,0.1)' }}>
                                                            <div
                                                                className="card-header d-flex justify-content-between align-items-center py-3"
                                                                style={{
                                                                    background: 'linear-gradient(135deg, rgba(13, 110, 253, 0.1) 0%, rgba(13, 110, 253, 0.05) 100%)',
                                                                    borderBottom: '2px solid rgba(13, 110, 253, 0.2)',
                                                                }}
                                                            >
                                                                <h6 className="mb-0 fw-bold d-flex align-items-center text-primary">
                                                                    <i className="bi bi-file-earmark-text me-2"></i>
                                                                    Policy Documents
                                                                </h6>
                                                                <span
                                                                    className="badge rounded-pill px-3 py-2"
                                                                    style={{
                                                                        background: 'linear-gradient(135deg, #0d6efd 0%, #0056b3 100%)',
                                                                        color: 'white',
                                                                    }}
                                                                >
                                                                    {policies.length} Documents
                                                                </span>
                                                            </div>
                                                            <div className="card-body p-0">
                                                                <div className="table-responsive">
                                                                    <table className="table table-hover align-middle mb-0">
                                                                        <thead style={{ backgroundColor: '#f8f9ff' }}>
                                                                            <tr>
                                                                                <th className="border-0 py-3 ps-4 text-uppercase text-muted fw-semibold small">Policy Name</th>
                                                                                <th className="border-0 py-3 text-uppercase text-muted fw-semibold small">Status</th>
                                                                                <th className="border-0 py-3 text-uppercase text-muted fw-semibold small">COI Number</th>
                                                                                <th className="border-0 py-3 pe-4 text-uppercase text-muted fw-semibold small text-end">Actions</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {policies.map((policy) => (
                                                                                <tr
                                                                                    key={policy.PoliciesId}
                                                                                    style={{ transition: 'all 0.2s ease', borderBottom: '1px solid #f0f0f0' }}

                                                                                >
                                                                                    <td className="py-3 ps-4">
                                                                                        <div className="d-flex align-items-center">
                                                                                            <div
                                                                                                className="rounded-circle d-flex align-items-center justify-content-center me-3"
                                                                                                style={{
                                                                                                    width: '45px',
                                                                                                    height: '45px',
                                                                                                    background: 'linear-gradient(135deg, #dc3545 0%, #c82333 100%)',
                                                                                                    color: 'white',
                                                                                                }}
                                                                                            >
                                                                                                <i className="bi bi-file-earmark-pdf"></i>
                                                                                            </div>
                                                                                            <div>
                                                                                                <a
                                                                                                    className="fw-semibold text-primary d-block mb-1 text-decoration-none"
                                                                                                    style={{ cursor: 'pointer', transition: 'color 0.2s ease' }}
                                                                                                    onClick={() => {
                                                                                                        setSelectedIndividualProduct(policy);
                                                                                                        setShowIndividualProducts(true);
                                                                                                    }}

                                                                                                >
                                                                                                    {policy.PoliciesProductName}
                                                                                                </a>
                                                                                                {policy.IsMembership && (
                                                                                                    <span
                                                                                                        className="badge rounded-pill"
                                                                                                        style={{
                                                                                                            background: 'linear-gradient(135deg, #17a2b8 0%, #138496 100%)',
                                                                                                            color: 'white',
                                                                                                        }}
                                                                                                    >
                                                                                                        Membership
                                                                                                    </span>
                                                                                                )}
                                                                                            </div>
                                                                                        </div>
                                                                                    </td>
                                                                                    <td className="py-3">
                                                                                        {policy.PolicyDocument ? (
                                                                                            <span className="badge bg-success rounded-pill">Available</span>
                                                                                        ) : (
                                                                                            <span className="badge bg-warning rounded-pill">Pending Upload</span>
                                                                                        )}
                                                                                    </td>
                                                                                    <td className="py-3">
                                                                                        {policy.PolicyCOINumber && policy.PolicyCOINumber.length > 0 ? (
                                                                                            <span className="fw-semibold text-dark">{policy.PolicyCOINumber}</span>
                                                                                        ) : (
                                                                                            <span className="text-muted">—</span>
                                                                                        )}
                                                                                    </td>
                                                                                    <td className="py-3 pe-4">
                                                                                        <div className="d-flex justify-content-end gap-2">
                                                                                            {policy.IsMembership ? (
                                                                                                <button
                                                                                                    className="btn btn-primary btn-sm rounded-pill px-3"
                                                                                                    onClick={handleGenerateMembership}
                                                                                                    disabled={gmcLoading}
                                                                                                    style={{
                                                                                                        transition: 'all 0.2s ease',
                                                                                                        minWidth: '100px',
                                                                                                        opacity: gmcLoading ? 0.7 : 1
                                                                                                    }}
                                                                                                    onMouseOver={(e) => {
                                                                                                        if (!gmcLoading) {
                                                                                                            e.target.style.transform = 'translateY(-1px)';
                                                                                                        }
                                                                                                    }}
                                                                                                    onMouseOut={(e) => {
                                                                                                        if (!gmcLoading) {
                                                                                                            e.target.style.transform = 'translateY(0)';
                                                                                                        }
                                                                                                    }}
                                                                                                >
                                                                                                    {gmcLoading ? (
                                                                                                        <>
                                                                                                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                                                                            Regenerating...
                                                                                                        </>
                                                                                                    ) : (
                                                                                                        <>
                                                                                                            <i className="bi bi-arrow-repeat me-1"></i>
                                                                                                            Regenerate
                                                                                                        </>
                                                                                                    )}
                                                                                                </button>
                                                                                            ) : (
                                                                                                <button
                                                                                                    className="btn btn-primary btn-sm rounded-pill px-3"
                                                                                                    data-bs-toggle="modal"
                                                                                                    data-bs-target="#exLargeModal"
                                                                                                    onClick={() => handleSelectPolicy(policy)}
                                                                                                    style={{ transition: 'all 0.2s ease' }}
                                                                                                    onMouseOver={(e) => e.target.style.transform = 'translateY(-1px)'}
                                                                                                    onMouseOut={(e) => e.target.style.transform = 'translateY(0)'}
                                                                                                >
                                                                                                    <i className="bi bi-upload me-1"></i>
                                                                                                    {policy.PolicyDocument ? 'Re-Upload' : 'Upload'}
                                                                                                </button>
                                                                                            )}
                                                                                            {policy.PolicyDocument && (
                                                                                                <a
                                                                                                    href={`${paUrl}${policy.PolicyDocument}`}
                                                                                                    className="btn btn-outline-secondary btn-sm rounded-pill"
                                                                                                    target="_blank"
                                                                                                    download
                                                                                                    style={{ transition: 'all 0.2s ease' }}
                                                                                                    onMouseOver={(e) => e.target.style.transform = 'translateY(-1px)'}
                                                                                                    onMouseOut={(e) => e.target.style.transform = 'translateY(0)'}
                                                                                                >
                                                                                                    <i className="bi bi-download"></i>
                                                                                                </a>
                                                                                            )}

                                                                                        </div>
                                                                                    </td>
                                                                                </tr>
                                                                            ))}
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                                {members && members.length > 0 && (
                                                    <div className="col-lg-8 mt-4">
                                                        <div className="card border-0 rounded-4 h-100" style={{ boxShadow: '0 0.25rem 1rem rgba(0,0,0,0.1)' }}>
                                                            <div
                                                                className="card-header d-flex justify-content-between align-items-center py-3"
                                                                style={{
                                                                    background: 'linear-gradient(135deg, rgba(13, 110, 253, 0.1) 0%, rgba(13, 110, 253, 0.05) 100%)',
                                                                    borderBottom: '2px solid rgba(13, 110, 253, 0.2)',
                                                                }}
                                                            >
                                                                <h6 className="mb-0 fw-bold d-flex align-items-center text-primary">
                                                                    <i className="bi bi-people me-2"></i>
                                                                    Members
                                                                </h6>
                                                            </div>
                                                            <div className="card-body p-0">
                                                                <div className="table-responsive">
                                                                    <table className="table table-hover align-middle mb-0">
                                                                        <thead style={{ backgroundColor: '#f8f9ff' }}>
                                                                            <tr>
                                                                                <th className="border-0 py-3 ps-4 text-uppercase text-muted fw-semibold small">Name</th>
                                                                                <th className="border-0 py-3 text-uppercase text-muted fw-semibold small">Relationship</th>
                                                                                <th className="border-0 py-3 text-uppercase text-muted fw-semibold small">DOB</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {members.map((member, index) => (
                                                                                <tr
                                                                                    key={index}
                                                                                    style={{ transition: 'all 0.2s ease', borderBottom: '1px solid #f0f0f0' }}

                                                                                >
                                                                                    <td className="py-3 ps-4">
                                                                                        <div className="d-flex align-items-center">
                                                                                            <div
                                                                                                className="rounded-circle d-flex align-items-center justify-content-center me-3"
                                                                                                style={{
                                                                                                    width: '45px',
                                                                                                    height: '45px',
                                                                                                    background: 'linear-gradient(135deg, #17a2b8 0%, #138496 100%)',
                                                                                                    color: 'white',
                                                                                                }}
                                                                                            >
                                                                                                <i className="bi bi-person"></i>
                                                                                            </div>
                                                                                            <div>
                                                                                                <span className="fw-semibold text-dark d-block mb-1">{member.name}</span>
                                                                                                {member.nominee && (
                                                                                                    <span
                                                                                                        className="badge rounded-pill"
                                                                                                        style={{
                                                                                                            background: 'linear-gradient(135deg, #dc3545 0%, #c82333 100%)',
                                                                                                            color: 'white',
                                                                                                        }}
                                                                                                    >
                                                                                                        Nominee
                                                                                                    </span>
                                                                                                )}
                                                                                            </div>
                                                                                        </div>
                                                                                    </td>
                                                                                    <td className="py-3">{member.relationship}</td>
                                                                                    <td className="py-3">{formatDate1(member.dateOfBirth)}</td>
                                                                                </tr>
                                                                            ))}
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </>
                                        )}
                                        {activeProductsTab === 'documents' && (
                                            <>
                                                {policies && policies.length > 0 && (
                                                    <div className="col-lg-8">
                                                        <div className="card border-0 rounded-4 h-100" style={{ boxShadow: '0 0.25rem 1rem rgba(0,0,0,0.1)' }}>
                                                            <div
                                                                className="card-header d-flex justify-content-between align-items-center py-3"
                                                                style={{
                                                                    background: 'linear-gradient(135deg, rgba(13, 110, 253, 0.1) 0%, rgba(13, 110, 253, 0.05) 100%)',
                                                                    borderBottom: '2px solid rgba(13, 110, 253, 0.2)',
                                                                }}
                                                            >
                                                                <h6 className="mb-0 fw-bold d-flex align-items-center text-primary">
                                                                    <i className="bi bi-file-earmark-text me-2"></i>
                                                                    Policy Documents
                                                                </h6>
                                                                <span
                                                                    className="badge rounded-pill px-3 py-2"
                                                                    style={{
                                                                        background: 'linear-gradient(135deg, #0d6efd 0%, #0056b3 100%)',
                                                                        color: 'white',
                                                                    }}
                                                                >
                                                                    {policies.length} Documents
                                                                </span>
                                                            </div>
                                                            <div className="card-body p-0">
                                                                <div className="table-responsive">
                                                                    <table className="table table-hover align-middle mb-0">
                                                                        <thead style={{ backgroundColor: '#f8f9ff' }}>
                                                                            <tr>
                                                                                <th className="border-0 py-3 ps-4 text-uppercase text-muted fw-semibold small">Policy Name</th>
                                                                                <th className="border-0 py-3 text-uppercase text-muted fw-semibold small">Status</th>
                                                                                <th className="border-0 py-3 text-uppercase text-muted fw-semibold small">COI Number</th>
                                                                                <th className="border-0 py-3 pe-4 text-uppercase text-muted fw-semibold small text-end">Actions</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {policies.map((policy) => (
                                                                                <tr
                                                                                    key={policy.PoliciesId}
                                                                                    style={{ transition: 'all 0.2s ease', borderBottom: '1px solid #f0f0f0' }}

                                                                                >
                                                                                    <td className="py-3 ps-4">
                                                                                        <div className="d-flex align-items-center">
                                                                                            <div
                                                                                                className="rounded-circle d-flex align-items-center justify-content-center me-3"
                                                                                                style={{
                                                                                                    width: '45px',
                                                                                                    height: '45px',
                                                                                                    background: 'linear-gradient(135deg, #dc3545 0%, #c82333 100%)',
                                                                                                    color: 'white',
                                                                                                }}
                                                                                            >
                                                                                                <i className="bi bi-file-earmark-pdf"></i>
                                                                                            </div>
                                                                                            <div>
                                                                                                <a
                                                                                                    className="fw-semibold text-primary d-block mb-1 text-decoration-none"
                                                                                                    style={{ cursor: 'pointer', transition: 'color 0.2s ease' }}
                                                                                                    onClick={() => {
                                                                                                        setSelectedIndividualProduct(policy);
                                                                                                        setShowIndividualProducts(true);
                                                                                                    }}

                                                                                                >
                                                                                                    {policy.PoliciesProductName}
                                                                                                </a>
                                                                                                {policy.IsMembership && (
                                                                                                    <span
                                                                                                        className="badge rounded-pill"
                                                                                                        style={{
                                                                                                            background: 'linear-gradient(135deg, #17a2b8 0%, #138496 100%)',
                                                                                                            color: 'white',
                                                                                                        }}
                                                                                                    >
                                                                                                        Membership
                                                                                                    </span>
                                                                                                )}
                                                                                            </div>
                                                                                        </div>
                                                                                    </td>
                                                                                    <td className="py-3">
                                                                                        {policy.PolicyDocument ? (
                                                                                            <span className="badge bg-success rounded-pill">Available</span>
                                                                                        ) : (
                                                                                            <span className="badge bg-warning rounded-pill">Pending Upload</span>
                                                                                        )}
                                                                                    </td>
                                                                                    <td className="py-3">
                                                                                        {policy.PolicyCOINumber && policy.PolicyCOINumber.length > 0 ? (
                                                                                            <span className="fw-semibold text-dark">{policy.PolicyCOINumber}</span>
                                                                                        ) : (
                                                                                            <span className="text-muted">—</span>
                                                                                        )}
                                                                                    </td>
                                                                                    <td className="py-3 pe-4">
                                                                                        <div className="d-flex justify-content-end gap-2">
                                                                                            {policy.IsMembership ? (
                                                                                                <button
                                                                                                    className="btn btn-primary btn-sm rounded-pill px-3"
                                                                                                    onClick={handleGenerateMembership}
                                                                                                    disabled={gmcLoading}
                                                                                                    style={{
                                                                                                        transition: 'all 0.2s ease',
                                                                                                        minWidth: '100px',
                                                                                                        opacity: gmcLoading ? 0.7 : 1
                                                                                                    }}
                                                                                                    onMouseOver={(e) => {
                                                                                                        if (!gmcLoading) {
                                                                                                            e.target.style.transform = 'translateY(-1px)';
                                                                                                        }
                                                                                                    }}
                                                                                                    onMouseOut={(e) => {
                                                                                                        if (!gmcLoading) {
                                                                                                            e.target.style.transform = 'translateY(0)';
                                                                                                        }
                                                                                                    }}
                                                                                                >
                                                                                                    {gmcLoading ? (
                                                                                                        <>
                                                                                                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                                                                            Regenerating...
                                                                                                        </>
                                                                                                    ) : (
                                                                                                        <>
                                                                                                            <i className="bi bi-arrow-repeat me-1"></i>
                                                                                                            Regenerate
                                                                                                        </>
                                                                                                    )}
                                                                                                </button>
                                                                                            ) : (
                                                                                                <button
                                                                                                    className="btn btn-primary btn-sm rounded-pill px-3"
                                                                                                    data-bs-toggle="modal"
                                                                                                    data-bs-target="#exLargeModal"
                                                                                                    onClick={() => handleSelectPolicy(policy)}
                                                                                                    style={{ transition: 'all 0.2s ease' }}
                                                                                                    onMouseOver={(e) => e.target.style.transform = 'translateY(-1px)'}
                                                                                                    onMouseOut={(e) => e.target.style.transform = 'translateY(0)'}
                                                                                                >
                                                                                                    <i className="bi bi-upload me-1"></i>
                                                                                                    {policy.PolicyDocument ? 'Re-Upload' : 'Upload'}
                                                                                                </button>
                                                                                            )}
                                                                                            {policy.PolicyDocument && (
                                                                                                <a
                                                                                                    href={`${paUrl}${policy.PolicyDocument}`}
                                                                                                    className="btn btn-outline-secondary btn-sm rounded-pill"
                                                                                                    target="_blank"
                                                                                                    download
                                                                                                    style={{ transition: 'all 0.2s ease' }}
                                                                                                    onMouseOver={(e) => e.target.style.transform = 'translateY(-1px)'}
                                                                                                    onMouseOut={(e) => e.target.style.transform = 'translateY(0)'}
                                                                                                >
                                                                                                    <i className="bi bi-download"></i>
                                                                                                </a>
                                                                                            )}
                                                                                        </div>
                                                                                    </td>
                                                                                </tr>
                                                                            ))}
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </>
                                        )}
                                        {activeProductsTab === 'members' && (
                                            <>
                                                {members && members.length > 0 && (
                                                    <div className="col-lg-8 mt-4">
                                                        <div className="card border-0 rounded-4 h-100" style={{ boxShadow: '0 0.25rem 1rem rgba(0,0,0,0.1)' }}>
                                                            <div
                                                                className="card-header d-flex justify-content-between align-items-center py-3"
                                                                style={{
                                                                    background: 'linear-gradient(135deg, rgba(13, 110, 253, 0.1) 0%, rgba(13, 110, 253, 0.05) 100%)',
                                                                    borderBottom: '2px solid rgba(13, 110, 253, 0.2)',
                                                                }}
                                                            >
                                                                <h6 className="mb-0 fw-bold d-flex align-items-center text-primary">
                                                                    <i className="bi bi-people me-2"></i>
                                                                    Members
                                                                </h6>
                                                            </div>
                                                            <div className="card-body p-0">
                                                                <div className="table-responsive">
                                                                    <table className="table table-hover align-middle mb-0">
                                                                        <thead style={{ backgroundColor: '#f8f9ff' }}>
                                                                            <tr>
                                                                                <th className="border-0 py-3 ps-4 text-uppercase text-muted fw-semibold small">Name</th>
                                                                                <th className="border-0 py-3 text-uppercase text-muted fw-semibold small">Relationship</th>
                                                                                <th className="border-0 py-3 text-uppercase text-muted fw-semibold small">DOB</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {members.map((member, index) => (
                                                                                <tr
                                                                                    key={index}
                                                                                    style={{ transition: 'all 0.2s ease', borderBottom: '1px solid #f0f0f0' }}

                                                                                >
                                                                                    <td className="py-3 ps-4">
                                                                                        <div className="d-flex align-items-center">
                                                                                            <div
                                                                                                className="rounded-circle d-flex align-items-center justify-content-center me-3"
                                                                                                style={{
                                                                                                    width: '45px',
                                                                                                    height: '45px',
                                                                                                    background: 'linear-gradient(135deg, #17a2b8 0%, #138496 100%)',
                                                                                                    color: 'white',
                                                                                                }}
                                                                                            >
                                                                                                <i className="bi bi-person"></i>
                                                                                            </div>
                                                                                            <div>
                                                                                                <span className="fw-semibold text-dark d-block mb-1">{member.name}</span>
                                                                                                {member.nominee && (
                                                                                                    <span
                                                                                                        className="badge rounded-pill"
                                                                                                        style={{
                                                                                                            background: 'linear-gradient(135deg, #dc3545 0%, #c82333 100%)',
                                                                                                            color: 'white',
                                                                                                        }}
                                                                                                    >
                                                                                                        Nominee
                                                                                                    </span>
                                                                                                )}
                                                                                            </div>
                                                                                        </div>
                                                                                    </td>
                                                                                    <td className="py-3">{member.relationship}</td>
                                                                                    <td className="py-3">{formatDate1(member.dateOfBirth)}</td>
                                                                                </tr>
                                                                            ))}
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </div>
                            ) : productsLoading ? (
                                <div className="d-flex flex-column justify-content-center align-items-center py-5">
                                    <div className="spinner-border text-success mb-3" role="status" style={{ width: "3rem", height: "3rem" }}>
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                    <p className="text-muted mb-0">Loading products...</p>
                                </div>
                            ) : products && products.length > 0 ? (
                                <div className="row row-cols-1 row-cols-md-2 row-cols-xl-3 g-4 mb-2">
                                    {products.map((product, index) => (
                                        product.ProductName ? (
                                            <div key={index} className="col">
                                                <div
                                                    className="card h-100 position-relative overflow-hidden rounded-4"
                                                    style={{
                                                        boxShadow: "0 0.25rem 1rem rgba(0,0,0,0.1)",
                                                        transition: "all 0.3s ease",
                                                        border: "none"
                                                    }}
                                                    onMouseOver={(e) => {
                                                        e.currentTarget.style.transform = "translateY(-8px)";
                                                        e.currentTarget.style.boxShadow = "0 1rem 2rem rgba(0,0,0,0.15)";
                                                    }}
                                                    onMouseOut={(e) => {
                                                        e.currentTarget.style.transform = "translateY(0)";
                                                        e.currentTarget.style.boxShadow = "0 0.25rem 1rem rgba(0,0,0,0.1)";
                                                    }}
                                                >
                                                    <div
                                                        className="position-absolute top-0 start-0 h-100"
                                                        style={{
                                                            width: "5px",
                                                            background: "linear-gradient(135deg, #4caf50 0%, #2e7d32 100%)"
                                                        }}
                                                    ></div>

                                                    <div className="position-absolute top-0 end-0 m-3">
                                                        <span
                                                            className="badge rounded-pill px-3 py-2 fw-normal"
                                                            style={{
                                                                background: product.IsCombo ?
                                                                    "linear-gradient(135deg, #0d6efd 0%, #0056b3 100%)" :
                                                                    "linear-gradient(135deg, #ffc107 0%, #e0a800 100%)",
                                                                color: "white",
                                                                fontSize: "0.8rem"
                                                            }}
                                                        >
                                                            {product.IsCombo ? "Combo" : "Individual"}
                                                        </span>
                                                    </div>

                                                    <div className="card-body pt-4 pb-3 px-4" style={{ padding: "1.5rem" }}>
                                                        <h5 className="card-title fw-bold mb-3 pe-5 text-dark">{product.ProductName}</h5>

                                                        {product.IssuedOn && product.ValidTill && (
                                                            <div className="d-flex align-items-center mb-3">
                                                                <div
                                                                    className="rounded-circle d-flex align-items-center justify-content-center me-3"
                                                                    style={{
                                                                        width: "45px",
                                                                        height: "45px",
                                                                        backgroundColor: "rgba(76, 175, 80, 0.1)"
                                                                    }}
                                                                >
                                                                    <i className="bi bi-calendar-check text-success"></i>
                                                                </div>
                                                                <div>
                                                                    <small className="text-muted d-block">Valid Until</small>
                                                                    <strong className="text-dark">{formatDate(product.ValidTill).slice(0, 11)}</strong>
                                                                </div>
                                                            </div>
                                                        )}

                                                        <div className="mt-3 d-flex align-items-center">
                                                            <div
                                                                className="rounded-circle d-flex align-items-center justify-content-center me-3"
                                                                style={{
                                                                    width: "45px",
                                                                    height: "45px",
                                                                    backgroundColor: "rgba(13, 110, 253, 0.1)"
                                                                }}
                                                            >
                                                                <i className="bi bi-file-earmark-text text-primary"></i>
                                                            </div>
                                                            <div className="progress flex-grow-1" style={{ height: "10px" }}>
                                                                <div
                                                                    className="progress-bar"
                                                                    role="progressbar"
                                                                    style={{
                                                                        width: "75%",
                                                                        background: "linear-gradient(135deg, #4caf50 0%, #2e7d32 100%)"
                                                                    }}
                                                                    aria-valuenow="75"
                                                                    aria-valuemin="0"
                                                                    aria-valuemax="100"
                                                                ></div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="card-footer bg-white border-0 d-flex justify-content-end py-3 px-4">
                                                        <button
                                                            className="btn rounded-pill fw-semibold px-4"
                                                            onClick={() => handleProductClick(product)}
                                                            style={{
                                                                background: "linear-gradient(135deg, #4caf50 0%, #2e7d32 100%)",
                                                                border: "none",
                                                                color: "white",
                                                                transition: "all 0.2s ease"
                                                            }}
                                                            onMouseOver={(e) => {
                                                                e.target.style.transform = "translateY(-2px)";
                                                            }}
                                                            onMouseOut={(e) => {
                                                                e.target.style.transform = "translateY(0)";
                                                            }}
                                                        >
                                                            View Details
                                                            <i className="bi bi-arrow-right ms-2"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        ) : null
                                    ))}
                                </div>
                            ) : (
                                <div className="text-center py-5">
                                    <div className="mb-4">
                                        <div
                                            className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
                                            style={{
                                                width: "100px",
                                                height: "100px",
                                                background: "linear-gradient(135deg, #2e7d32 0%, #4caf50 100%)",
                                                opacity: "0.1"
                                            }}
                                        >
                                            <i className="bi bi-box" style={{ fontSize: "3rem", color: "#1b5e20" }}></i>
                                        </div>
                                    </div>
                                    <h5 className="text-dark mb-3 fw-bold">No Products Available</h5>
                                    <p className="text-muted mb-4">You haven't purchased any products yet.</p>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>


            <div className="col-md-12 mb-4 mt-5">
                <div className="card border-0 rounded-4 overflow-hidden" style={{ boxShadow: "0 0.5rem 1.5rem rgba(0,0,0,0.15)" }}>
                    {/* Header with gradient background */}
                    <div className="card-header border-0 py-4" style={{
                        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                        position: "relative"
                    }}>
                        <div className="d-flex justify-content-between align-items-center">
                            <div className="d-flex align-items-center">
                                <div className="rounded-3 p-2 me-3" style={{ backgroundColor: "rgba(255,255,255,0.2)" }}>
                                    <i className="bi bi-telephone-fill text-white fs-5"></i>
                                </div>
                                <div>
                                    <h4 className="text-white mb-0 fw-bold">Call History</h4>
                                    <p className="text-white mb-0 small" style={{ opacity: "0.7" }}>Track all your important calls</p>
                                </div>
                            </div>

                            <button
                                className="btn btn-light d-flex align-items-center gap-2 rounded-pill px-4 py-2 shadow-sm"
                                data-bs-toggle="modal"
                                data-bs-target="#exLargeModalCallLog"
                                style={{
                                    transition: "all 0.3s ease",
                                    fontWeight: "600"
                                }}
                                onMouseOver={(e) => {
                                    e.target.style.transform = "translateY(-2px)";
                                    e.target.style.boxShadow = "0 8px 25px rgba(0,0,0,0.15)";
                                }}
                                onMouseOut={(e) => {
                                    e.target.style.transform = "translateY(0)";
                                    e.target.style.boxShadow = "0 0.125rem 0.25rem rgba(0,0,0,0.075)";
                                }}
                            >
                                <i className="bi bi-plus-circle-fill text-primary"></i>
                                <span>New Call</span>
                            </button>
                        </div>
                    </div>

                    <div className="card-body p-0">
                        {callHistoryLoading ? (
                            <div className="d-flex flex-column justify-content-center align-items-center py-5">
                                <div className="spinner-border text-primary mb-3" role="status" style={{ width: "3rem", height: "3rem" }}>
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                                <p className="text-muted mb-0">Loading call history...</p>
                            </div>
                        ) : callHistory && callHistory.length > 0 ? (
                            <div className="table-responsive">
                                <table className="table table-hover mb-0">
                                    <thead style={{ backgroundColor: "#f8f9ff" }}>
                                        <tr>
                                            <th className="border-0 py-3 ps-4 text-uppercase text-muted fw-semibold small">
                                                <i className="bi bi-person-fill me-2"></i>Contact Person
                                            </th>
                                            <th className="border-0 py-3 text-uppercase text-muted fw-semibold small">
                                                <i className="bi bi-chat-dots me-2"></i>Response
                                            </th>
                                            <th className="border-0 py-3 text-uppercase text-muted fw-semibold small">
                                                <i className="bi bi-clock me-2"></i>Date & Time
                                            </th>
                                            <th className="border-0 py-3 pe-4 text-uppercase text-muted fw-semibold small">
                                                <i className="bi bi-chat-square-text me-2"></i>Remarks
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {callHistory.map((call, index) => (
                                            <tr
                                                key={index}
                                                className="border-bottom"
                                                style={{
                                                    transition: "all 0.2s ease",
                                                    borderBottom: "1px solid #f0f0f0 !important"
                                                }}
                                                onMouseOver={(e) => {
                                                    e.currentTarget.style.backgroundColor = "#f8f9ff";
                                                    e.currentTarget.style.transform = "translateX(4px)";
                                                }}
                                                onMouseOut={(e) => {
                                                    e.currentTarget.style.backgroundColor = "";
                                                    e.currentTarget.style.transform = "translateX(0)";
                                                }}
                                            >
                                                <td className="py-3 ps-4">
                                                    <div className="d-flex align-items-center">
                                                        <div className="rounded-circle p-2 me-3" style={{ backgroundColor: "rgba(102, 126, 234, 0.1)" }}>
                                                            <i className="bi bi-person-fill small" style={{ color: "#667eea" }}></i>
                                                        </div>
                                                        <div>
                                                            <span className="fw-semibold text-dark">{call.UserName}</span>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td className="py-3">
                                                    <span
                                                        className="badge rounded-pill px-3 py-2 fw-normal"
                                                        style={{
                                                            background: "linear-gradient(45deg, #36d1dc, #5b86e5)",
                                                            color: "white",
                                                            fontSize: "0.8rem",
                                                            transition: "all 0.2s ease"
                                                        }}
                                                        onMouseOver={(e) => {
                                                            e.target.style.transform = "scale(1.05)";
                                                        }}
                                                        onMouseOut={(e) => {
                                                            e.target.style.transform = "scale(1)";
                                                        }}
                                                    >
                                                        {call.CallResponseName}
                                                    </span>
                                                </td>
                                                <td className="py-3">
                                                    <div className="d-flex align-items-center text-muted">
                                                        <i className="bi bi-calendar3 me-2 small"></i>
                                                        {moment(call.CollectedDate).local().diff(moment(), "days") <= thresholdDays ? (
                                                            <span className="small">
                                                                {moment(call.CollectedDate).local().fromNow()}
                                                            </span>
                                                        ) : (
                                                            <span className="small">
                                                                {moment(call.CollectedDate).local().format("DD-MMM-YYYY h:mm A")}
                                                            </span>
                                                        )}
                                                    </div>
                                                </td>
                                                <td className="py-3 pe-4">
                                                    {call.CallLog && call.CallLog.trim() !== "" ? (
                                                        <div
                                                            className="text-truncate bg-light rounded-pill px-3 py-1"
                                                            style={{
                                                                maxWidth: "250px",
                                                                fontSize: "0.85rem",
                                                                color: "#6c757d"
                                                            }}
                                                            title={call.CallLog}
                                                        >
                                                            <i className="bi bi-chat-left-text me-2 small"></i>
                                                            {call.CallLog}
                                                        </div>
                                                    ) : (
                                                        <span className="text-muted small fst-italic">
                                                            <i className="bi bi-dash-circle me-2"></i>
                                                            No remarks
                                                        </span>
                                                    )}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        ) : (
                            <div className="text-center py-5">
                                <div className="mb-4">
                                    <div
                                        className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
                                        style={{
                                            width: "80px",
                                            height: "80px",
                                            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                                            opacity: "0.1"
                                        }}
                                    >
                                        <i className="bi bi-telephone" style={{ fontSize: "2rem", color: "#040000dd" }}></i>
                                    </div>
                                </div>
                                <h5 className="text-dark mb-2 fw-bold">No Call History Yet</h5>
                                <p className="text-muted mb-4">Start tracking your calls by adding your first call record</p>
                                <button
                                    className="btn btn-primary rounded-pill px-4 py-2 shadow-sm d-inline-flex align-items-center gap-2"
                                    data-bs-toggle="modal"
                                    data-bs-target="#exLargeModalCallLog"
                                    style={{
                                        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                                        border: "none",
                                        fontWeight: "600",
                                        transition: "all 0.3s ease"
                                    }}
                                    onMouseOver={(e) => {
                                        e.target.style.transform = "translateY(-1px)";
                                    }}
                                    onMouseOut={(e) => {
                                        e.target.style.transform = "translateY(0)";
                                    }}
                                >
                                    <i className="bi bi-plus-circle-fill"></i>
                                    <span>Add Your First Call</span>
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            <div id="services">
                <div className="col-md-12 mb-4">
                    <div className="card shadow-sm border-0 overflow-hidden">
                        {/* Header with gradient background */}
                        <div
                            className="card-header d-flex align-items-center py-3 border-0"
                            style={{
                                background: "linear-gradient(90deg, #00695c, #00acc1)",
                            }}
                        >
                            <h4 className="m-0 fw-bold text-white">
                                <i className="bi bi-tools me-2 text-white"></i> Services
                            </h4>
                        </div>



                        {/* Tabs with modern styling */}
                        <div className="card-header bg-white border-bottom py-2 px-4 d-flex gap-2">
                            {["claimServices", "activity", "requestedCoupons"].map((tab) => (
                                <button
                                    key={tab}
                                    className={`btn btn-sm fw-semibold position-relative overflow-hidden ${activeServiceTab === tab ? "text-white" : "text-dark"}`}
                                    style={{
                                        background: activeServiceTab === tab
                                            ? "linear-gradient(135deg, #008080 0%, #00a3a3 100%)"
                                            : "linear-gradient(135deg, #f5f5f5 0%, #e0e0e0 100%)",
                                        borderRadius: "8px",
                                        padding: "10px 16px",
                                        border: "none",
                                        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                        transition: "all 0.3s ease",
                                        zIndex: 1
                                    }}
                                    onClick={() => {
                                        setActiveServiceTab(tab);
                                        if (tab === "requestedCoupons") fetchRequestedCoupons();
                                    }}
                                    onMouseEnter={(e) => {
                                        if (activeServiceTab !== tab) {
                                            e.currentTarget.style.background = "linear-gradient(135deg, #e0e0e0 0%, #d0d0d0 100%)";
                                        }
                                    }}
                                    onMouseLeave={(e) => {
                                        if (activeServiceTab !== tab) {
                                            e.currentTarget.style.background = "linear-gradient(135deg, #f5f5f5 0%, #e0e0e0 100%)";
                                        }
                                    }}
                                >
                                    <i className={`bi ${tab === "claimServices" ? "bi-clipboard-check"
                                        : tab === "activity" ? "bi-clock-history"
                                            : "bi-ticket-perforated"
                                        } me-1`}></i>
                                    {tab === "claimServices" ? "Claimed Services"
                                        : tab === "activity" ? "Activity"
                                            : "Requested Coupons"}
                                    {activeServiceTab === tab && (
                                        <span className="position-absolute bottom-0 start-0 w-100 bg-white" style={{
                                            height: "3px",
                                            opacity: 0.8,
                                            borderRadius: "0 0 8px 8px"
                                        }}></span>
                                    )}
                                </button>
                            ))}
                        </div>

                        {/* Main Content */}
                        {activeServiceTab === "claimServices" && (
                            <div className="container-fluid my-1 p-3">
                                {claimedDate && claimedDate.length > 0 ? (
                                    <div className="row g-3">
                                        {claimedDate.map((consultation, index) => (
                                            <div
                                                key={index}
                                                className="col-12"
                                            >
                                                <div
                                                    className="card border-0 shadow-sm rounded-4 position-relative overflow-hidden h-100"
                                                    style={{
                                                        background: "linear-gradient(to right, #ffffff 0%, #f9f9f9 100%)",
                                                        borderLeft: `6px solid ${statusColors[consultation.StatusName]?.bg || "#6c757d"}`,
                                                        transition: "all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1)",
                                                        cursor: "pointer"
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        e.currentTarget.style.transform = "translateY(-5px)";
                                                        e.currentTarget.style.boxShadow = "0 6px 12px rgba(0,0,0,0.1)";
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.currentTarget.style.transform = "translateY(0)";
                                                        e.currentTarget.style.boxShadow = "0 2px 4px rgba(0,0,0,0.1)";
                                                    }}
                                                >
                                                    {/* Status Indicator */}
                                                    <div className="card-body d-flex align-items-center p-3">
                                                        <div
                                                            className="d-flex flex-column justify-content-center align-items-center px-3 me-3"
                                                            style={{
                                                                borderRight: "1px solid rgba(0,0,0,0.05)",
                                                                minWidth: "80px"
                                                            }}
                                                        >
                                                            <div
                                                                className="rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                                                                style={{
                                                                    width: "50px",
                                                                    height: "50px",
                                                                    background: `linear-gradient(135deg, ${statusColors[consultation.StatusName]?.bg || "#f8f9fa"} 0%, ${statusColors[consultation.StatusName]?.bg || "#f8f9fa"}80 100%)`,
                                                                    color: statusColors[consultation.StatusName]?.text || "#000",
                                                                    fontSize: "1.3rem",
                                                                    border: `2px solid ${statusColors[consultation.StatusName]?.bg || "#f8f9fa"}`
                                                                }}
                                                            >
                                                                {consultation.StatusName === "Booked " && <i className="fas fa-check-circle"></i>}
                                                                {consultation.StatusName === "Visited" && <i className="fas fa-clock"></i>}
                                                                {consultation.StatusName === 'Initiated' && <i className="fas fa-times-circle"></i>}
                                                                {!["Booked", "Visited", "Initiated"].includes(consultation.StatusName) && <i className="fas fa-calendar"></i>}
                                                            </div>
                                                            <span className="small fw-bold mt-2" style={{
                                                                color: statusColors[consultation.StatusName]?.bg || "#6c757d"
                                                            }}>
                                                                {consultation.StatusName}
                                                            </span>
                                                        </div>

                                                        {/* Main Content */}
                                                        <div className="flex-grow-1">
                                                            <div className="d-flex flex-column">
                                                                {/* Name & Hospital */}
                                                                <div className="d-flex flex-wrap justify-content-between mb-2">
                                                                    <div className="d-flex align-items-center">
                                                                        <i className="fas fa-user me-2" style={{ color: "#008080" }}></i>
                                                                        <span className="fw-bold text-dark">{consultation.Name || "Unknown"}</span>
                                                                    </div>
                                                                    <div className="d-flex align-items-center">
                                                                        <i className="fas fa-hospital me-2" style={{ color: "#6f42c1" }}></i>
                                                                        <span className="text-muted">{consultation.HospitalName || "N/A"}</span>
                                                                    </div>
                                                                </div>

                                                                {/* Date & Time */}
                                                                <div className="d-flex flex-wrap justify-content-between align-items-center mb-2">
                                                                    <div className="d-flex align-items-center">
                                                                        <i className="fas fa-calendar-alt me-2" style={{ color: "#dc3545" }}></i>
                                                                        <span className="text-muted">
                                                                            {consultation.AppointmentDate
                                                                                ? new Date(consultation.AppointmentDate).toLocaleDateString("en-US", {
                                                                                    weekday: 'short',
                                                                                    year: "numeric",
                                                                                    month: "short",
                                                                                    day: "2-digit",
                                                                                    hour: '2-digit',
                                                                                    minute: '2-digit'
                                                                                })
                                                                                : "N/A"}
                                                                        </span>
                                                                    </div>
                                                                </div>

                                                                {/* Coupon Status */}
                                                                {consultation.PoliciesType === "Free Consultation" && (
                                                                    <div className="mt-1">
                                                                        <span
                                                                            className={`badge d-inline-flex align-items-center px-3 py-1 ${consultation.IsCouponClaimed ? "bg-success" : "bg-secondary"}`}
                                                                            style={{
                                                                                borderRadius: "20px",
                                                                                fontSize: "0.75rem",
                                                                                fontWeight: 500
                                                                            }}
                                                                        >
                                                                            <i className="fas fa-ticket-alt me-2"></i>
                                                                            {consultation.IsCouponClaimed ? "Coupon Claimed" : "Unclaimed Coupon"}
                                                                        </span>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                ) : (
                                    <div className="text-center p-5 bg-light border-0 rounded-4 shadow-sm"
                                        style={{
                                            background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
                                            border: "2px dashed #dee2e6"
                                        }}>
                                        <div className="position-relative d-inline-block mb-4">
                                            <div className="bg-white rounded-circle p-4 shadow-sm">
                                                <i className="fas fa-calendar-alt text-muted" style={{ fontSize: "2.5rem" }}></i>
                                            </div>
                                            <div className="position-absolute top-0 end-0 translate-middle">
                                                <span className="badge rounded-circle bg-primary p-2 d-flex align-items-center justify-content-center"
                                                    style={{ width: "30px", height: "30px" }}>
                                                    <i className="fas fa-plus" style={{ fontSize: "0.8rem" }}></i>
                                                </span>
                                            </div>
                                        </div>
                                        <h5 className="text-dark fw-bold mb-3">No Consultations Scheduled</h5>
                                        <p className="text-muted mb-4 mx-auto" style={{ maxWidth: "500px" }}>
                                            Your health journey begins here. Schedule your first consultation to get started with personalized care.
                                        </p>
                                        <button className="btn btn-primary rounded-pill px-4 py-2" onClick={(e) => handleBookService(e)}>
                                            <i className="fas fa-plus me-2"></i> Book Consultation
                                        </button>
                                    </div>
                                )}
                            </div>
                        )}

                        {/* Activity Section */}
                        {activeServiceTab === "activity" && (
                            <div className="container-fluid p-3">
                                <div className="d-flex align-items-center mb-4">
                                    <h6 className="mb-0 text-dark fw-bold">
                                        <i className="bi bi-clock-history me-2 text-primary"></i>
                                        Recent Activity
                                    </h6>
                                    {/* <div className="ms-auto">
                    <span className="badge bg-light text-dark rounded-pill px-3 py-2">
                      <i className="fas fa-filter me-1"></i> Filter
                    </span>
                  </div> */}
                                </div>

                                {/* Sub-tabs with modern styling */}
                                <div className="d-flex gap-2 mb-4 flex-wrap">
                                    {[
                                        { id: "all", label: "All Activity", icon: "bi-grid" },
                                        { id: "booking", label: "Bookings", icon: "bi-calendar-check" },
                                        { id: "feedback", label: "Feedback", icon: "bi-chat-square-text" }
                                    ].map((tab) => (
                                        <button
                                            key={tab.id}
                                            className={`btn btn-sm fw-semibold d-flex align-items-center position-relative ${activeActivityTab === tab.id ? 'bg-primary text-white' : 'bg-light text-dark'}`}
                                            style={{
                                                borderRadius: "20px",
                                                padding: "8px 16px",
                                                transition: "all 0.3s ease",
                                                border: "none",
                                                boxShadow: activeActivityTab === tab.id ? "0 4px 8px rgba(0,128,128,0.2)" : "0 2px 4px rgba(0,0,0,0.05)"
                                            }}
                                            onClick={() => setActiveActivityTab(tab.id)}
                                        >
                                            <i className={`bi ${tab.icon} me-2`}></i>
                                            {tab.label}
                                            {activeActivityTab === tab.id && (
                                                <span className="position-absolute bottom-0 start-50 translate-middle-x bg-white"
                                                    style={{
                                                        width: "20px",
                                                        height: "3px",
                                                        borderRadius: "3px",
                                                        opacity: 0.8
                                                    }}></span>
                                            )}
                                        </button>
                                    ))}
                                </div>

                                {/* Activity Content */}
                                <div className="card border-0 shadow-none">
                                    {loading ? (
                                        <div className="card-body text-center py-5">
                                            <div className="spinner-grow text-primary" role="status" style={{ width: "3rem", height: "3rem" }}>
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                            <p className="text-muted mt-3 fw-semibold">Loading activities...</p>
                                        </div>
                                    ) : (
                                        (() => {
                                            const filteredActivities = activity.filter(item =>
                                                activeActivityTab === "all" || (item.ActivityCategory?.toLowerCase() === activeActivityTab.toLowerCase())
                                            );

                                            if (filteredActivities.length > 0) {
                                                return (
                                                    <div className="container-fluid p-0">
                                                        <div className="list-group gap-3">
                                                            {filteredActivities.map((item, index) => {
                                                                const status = statusConfig[item.StatusName] || statusConfig.default;

                                                                return (
                                                                    <div
                                                                        key={index}
                                                                        className="list-group-item border-0 p-0 bg-transparent"
                                                                    >
                                                                        <div
                                                                            className="card border-0 shadow-sm rounded-4 overflow-hidden h-100"
                                                                            style={{
                                                                                background: "linear-gradient(to right, #ffffff 0%, #f9f9f9 100%)",
                                                                                transition: "all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1)"
                                                                            }}
                                                                            onMouseEnter={(e) => {
                                                                                e.currentTarget.style.transform = "translateY(-3px)";
                                                                                e.currentTarget.style.boxShadow = "0 6px 12px rgba(0,0,0,0.1)";
                                                                            }}
                                                                            onMouseLeave={(e) => {
                                                                                e.currentTarget.style.transform = "translateY(0)";
                                                                                e.currentTarget.style.boxShadow = "0 2px 4px rgba(0,0,0,0.1)";
                                                                            }}
                                                                        >
                                                                            <div className="card-body p-3">
                                                                                {/* Header */}
                                                                                <div className="d-flex align-items-center mb-3">
                                                                                    <div className="me-3">
                                                                                        <div
                                                                                            className="rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                                                                                            style={{
                                                                                                width: "40px",
                                                                                                height: "40px",
                                                                                                background: "linear-gradient(135deg, #008080 0%, #00a3a3 100%)",
                                                                                                color: "white"
                                                                                            }}
                                                                                        >
                                                                                            <i className="fas fa-user-circle"></i>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="flex-grow-1">
                                                                                        <h6 className="mb-0 text-truncate fw-semibold" style={{ fontSize: "0.95rem" }}>
                                                                                            {item.Name || "Unknown"}
                                                                                        </h6>
                                                                                        <small className="text-muted">
                                                                                            {new Date(item.CreatedDate).toLocaleString('en-US', {
                                                                                                month: 'short',
                                                                                                day: 'numeric',
                                                                                                hour: '2-digit',
                                                                                                minute: '2-digit'
                                                                                            })}
                                                                                        </small>
                                                                                    </div>
                                                                                    <span
                                                                                        className="badge rounded-pill px-3 py-1 fw-normal"
                                                                                        style={{
                                                                                            background: status.color,
                                                                                            color: status.textColor,
                                                                                            fontSize: "0.75rem",
                                                                                            minWidth: "80px"
                                                                                        }}
                                                                                    >
                                                                                        <i className={`fas fa-${status.icon} me-1`}></i>
                                                                                        {item.StatusName}
                                                                                    </span>
                                                                                </div>

                                                                                {/* Content */}
                                                                                <div className="row g-2" style={{ fontSize: "0.85rem" }}>
                                                                                    {/* Hospital */}
                                                                                    <div className="col-md-6 d-flex align-items-center">
                                                                                        <i className="fas fa-hospital me-2" style={{ color: "#6f42c1", minWidth: "20px" }}></i>
                                                                                        <span className="text-truncate">{item.HospitalName || "N/A"}</span>
                                                                                    </div>

                                                                                    {/* Policy Type */}
                                                                                    <div className="col-md-6 d-flex align-items-center">
                                                                                        <i className="fas fa-shield-alt me-2" style={{ color: "#fd7e14", minWidth: "20px" }}></i>
                                                                                        <span className="text-truncate">{item.PoliciesType || "N/A"}</span>
                                                                                    </div>

                                                                                    {/* Action By */}
                                                                                    <div className="col-md-6 d-flex align-items-center">
                                                                                        <i className="fas fa-user-md me-2" style={{ color: "#20c997", minWidth: "20px" }}></i>
                                                                                        <span className="text-truncate">Action By: {item.EmployeeName || "Self"}</span>
                                                                                    </div>

                                                                                    {/* Feedback Section */}
                                                                                    {(activeActivityTab === "feedback" || activeActivityTab === "all") && (
                                                                                        (item.CustomerFeedback || item.Hospitalfeedback) && (
                                                                                            <div className="col-12 mt-2">
                                                                                                <div className={`p-3 rounded-3 ${activeActivityTab === "feedback" ? "bg-light" : "bg-soft-primary"}`}>
                                                                                                    {item.StatusName === "Customer Feedback" && item.CustomerFeedback && (
                                                                                                        <div className="d-flex align-items-start mb-2">
                                                                                                            <i className="fas fa-comment-alt me-2 mt-1" style={{ color: "#008080" }}></i>
                                                                                                            <div>
                                                                                                                <span className="fw-semibold d-block mb-1">Customer Feedback:</span>
                                                                                                                <p className="mb-0 text-muted" style={{ fontSize: "0.85rem" }}>
                                                                                                                    {item.CustomerFeedback}
                                                                                                                </p>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    )}

                                                                                                    {item.StatusName === "Hospital Feedback" && item.Hospitalfeedback && (
                                                                                                        <div className="d-flex align-items-start">
                                                                                                            <i className="fas fa-comment-medical me-2 mt-1" style={{ color: "#6f42c1" }}></i>
                                                                                                            <div>
                                                                                                                <span className="fw-semibold d-block mb-1">Hospital Feedback:</span>
                                                                                                                <p className="mb-0 text-muted" style={{ fontSize: "0.85rem" }}>
                                                                                                                    {item.Hospitalfeedback}
                                                                                                                </p>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    )}
                                                                                                </div>
                                                                                            </div>
                                                                                        )
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                );
                                                            })}
                                                        </div>
                                                    </div>
                                                );
                                            } else {
                                                return (
                                                    <div className="text-center py-5">
                                                        <div className="bg-soft-primary rounded-circle p-4 d-inline-block mb-3">
                                                            <i className="bi bi-inbox text-primary" style={{ fontSize: "2rem" }}></i>
                                                        </div>
                                                        <h5 className="text-dark fw-bold mb-2">No Activities Found</h5>
                                                        <p className="text-muted mb-4">
                                                            {activeActivityTab === "all"
                                                                ? "You don't have any activities yet."
                                                                : `You don't have any ${activeActivityTab} activities yet.`}
                                                        </p>
                                                        <button className="btn btn-outline-primary rounded-pill px-4">
                                                            <i className="fas fa-sync-alt me-2"></i> Refresh
                                                        </button>
                                                    </div>
                                                );
                                            }
                                        })()
                                    )}
                                </div>
                            </div>
                        )}

                        {activeServiceTab === "requestedCoupons" && (
                            <div className="container-fluid p-3">
                                <div className="d-flex align-items-center mb-4">
                                    <h6 className="mb-0 text-dark fw-bold">
                                        <i className="bi bi-ticket-perforated me-2 text-primary"></i>
                                        Requested Coupons History
                                    </h6>
                                    <span className="ms-auto badge rounded-pill px-3 py-2"
                                        style={{ background: "linear-gradient(135deg, #008080 0%, #00a3a3 100%)", color: "white" }}>
                                        {requestedCoupons?.length} {(requestedCoupons?.length) === 1 ? "Record" : "Records"}
                                    </span>
                                </div>

                                {requestedCouponsLoading ? (
                                    <div className="d-flex flex-column justify-content-center align-items-center py-5">
                                        <div className="spinner-grow text-primary mb-3" role="status" style={{ width: "3rem", height: "3rem" }}>
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                        <p className="text-muted fw-semibold">Loading coupon history...</p>
                                    </div>
                                ) : requestedCoupons && requestedCoupons.length > 0 ? (
                                    <div className="table-responsive rounded-4 overflow-hidden shadow-sm">
                                        <table className="table table-hover align-middle mb-0">
                                            <thead>
                                                <tr style={{ background: "linear-gradient(135deg, #008080 0%, #00a3a3 100%)" }}>
                                                    <th className="border-0 py-3 ps-4 text-white fw-semibold small text-uppercase">
                                                        <i className="bi bi-person-fill me-1"></i> Name
                                                    </th>
                                                    <th className="border-0 py-3 text-white fw-semibold small text-uppercase">
                                                        <i className="bi bi-ticket me-1"></i> Coupons
                                                    </th>
                                                    <th className="border-0 py-3 text-white fw-semibold small text-uppercase">
                                                        <i className="bi bi-calendar-event me-1"></i> Requested Date
                                                    </th>
                                                    <th className="border-0 py-3 text-white fw-semibold small text-uppercase">
                                                        <i className="bi bi-hourglass-split me-1"></i> End Date
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody style={{ backgroundColor: "#fff" }}>
                                                {requestedCoupons.map((coupon, index) => (
                                                    <tr
                                                        key={coupon.requestedCouponsId}
                                                        style={{
                                                            borderBottom: "1px solid #f0f0f0",
                                                            transition: "all 0.2s ease",
                                                            backgroundColor: index % 2 === 0 ? "#fff" : "#f9fffe"
                                                        }}
                                                        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#e6f7f7"}
                                                        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = index % 2 === 0 ? "#fff" : "#f9fffe"}
                                                    >
                                                        <td className="py-3 ps-4">
                                                            <div className="d-flex align-items-center">
                                                                <div
                                                                    className="rounded-circle d-flex align-items-center justify-content-center me-3"
                                                                    style={{
                                                                        width: "38px",
                                                                        height: "38px",
                                                                        flexShrink: 0,
                                                                        background: "linear-gradient(135deg, #008080 0%, #00a3a3 100%)",
                                                                        color: "white",
                                                                        fontSize: "0.9rem",
                                                                        fontWeight: "700"
                                                                    }}
                                                                >
                                                                    <i className="bi bi-person-fill"></i>
                                                                </div>

                                                                <div>
                                                                    <div
                                                                        className="fw-semibold text-dark"
                                                                        style={{ fontSize: "0.95rem" }}
                                                                    >
                                                                        {coupon.name}
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        </td>

                                                        {/* Number of Coupons */}
                                                        <td className="py-3">
                                                            <div className="d-flex align-items-center gap-2">
                                                                <span
                                                                    className="badge rounded-pill px-3 py-2 fw-bold"
                                                                    style={{
                                                                        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                                                                        color: "white", fontSize: "0.9rem"
                                                                    }}
                                                                >
                                                                    <i className="bi bi-ticket-perforated me-1"></i>
                                                                    {coupon.numberOfCoupons}
                                                                </span>
                                                            </div>
                                                        </td>

                                                        {/* Requested Date */}
                                                        <td className="py-3">
                                                            <div className="d-flex flex-column">
                                                                <span className="fw-semibold text-dark" style={{ fontSize: "0.88rem" }}>
                                                                    {coupon.requestedDate
                                                                        ? new Date(coupon.requestedDate).toLocaleDateString("en-IN", {
                                                                            day: "2-digit", month: "short", year: "numeric"
                                                                        })
                                                                        : "—"}
                                                                </span>
                                                                <small className="text-muted">
                                                                    {coupon.requestedDate
                                                                        ? new Date(coupon.requestedDate).toLocaleTimeString("en-IN", {
                                                                            hour: "2-digit", minute: "2-digit"
                                                                        })
                                                                        : ""}
                                                                </small>
                                                            </div>
                                                        </td>

                                                        {/* End Date */}
                                                        <td className="py-3">
                                                            {coupon.endDate ? (
                                                                <div className="d-flex flex-column">
                                                                    <span className="fw-semibold text-dark" style={{ fontSize: "0.88rem" }}>
                                                                        {new Date(coupon.endDate).toLocaleDateString("en-IN", {
                                                                            day: "2-digit", month: "short", year: "numeric"
                                                                        })}
                                                                    </span>
                                                                    <small className="text-muted">
                                                                        {new Date(coupon.endDate) > new Date()
                                                                            ? <span className="text-success"><i className="bi bi-check-circle me-1"></i>Active</span>
                                                                            : <span className="text-danger"><i className="bi bi-x-circle me-1"></i>Expired</span>}
                                                                    </small>
                                                                </div>
                                                            ) : (
                                                                <span className="text-muted fst-italic small">No expiry</span>
                                                            )}
                                                        </td>

                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                ) : (
                                    <div className="text-center py-5">
                                        <div
                                            className="bg-soft-primary rounded-circle p-4 d-inline-block mb-3"
                                        >
                                            <i className="bi bi-ticket-perforated" style={{ fontSize: "2.5rem", color: "#008080" }}></i>
                                        </div>
                                        <h5 className="text-dark fw-bold mb-2">No Coupon Requests Found</h5>
                                        <p className="text-muted mb-4">This customer hasn't requested any coupons yet.</p>
                                        <button
                                            className="btn btn-outline-primary rounded-pill px-4 d-inline-flex align-items-center gap-2"
                                            onClick={fetchRequestedCoupons}
                                            style={{
                                                transition: "all 0.3s ease",
                                                fontWeight: "500"
                                            }}
                                            onMouseOver={(e) => {
                                                e.target.style.transform = "translateY(-2px)";
                                                e.target.style.boxShadow = "0 4px 12px rgba(0,0,0,0.1)";
                                            }}
                                            onMouseOut={(e) => {
                                                e.target.style.transform = "translateY(0)";
                                                e.target.style.boxShadow = "none";
                                            }}
                                        >
                                            <i className="bi bi-arrow-clockwise"></i>
                                            Refresh
                                        </button>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>
            {/* )} */}


            <div
                className="modal fade"
                id="exLargeModalCallLog"
                tabIndex="-1"
                aria-hidden="true"
                aria-labelledby="exampleModalLabel4"
            >
                <div className="modal-dialog modal-lg modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title" id="exampleModalLabel4">
                                Add Call History
                            </h4>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>

                        <form onSubmit={onSubmitHandler} className="p-4">
                            <div className="mb-4">
                                <h5 className="mb-3" style={{ fontWeight: "bold" }}>
                                    Call Response{" "}
                                    <span className="required" style={{ color: "red" }}>
                                        {" "}
                                        *
                                    </span>
                                </h5>

                                <div className="d-flex flex-wrap">
                                    {callResponseOptions.map((option) => (
                                        <div
                                            className="form-check me-4 mb-2 col-5"
                                            key={option.CallResponsesId}
                                        >
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                id={`callResponse_${option.CallResponsesId}`}
                                                name="callResponsesId"
                                                value={option.CallResponsesId}
                                                checked={formData.callResponsesId.includes(
                                                    option.CallResponsesId
                                                )}
                                                onChange={onChangeHandler}
                                            />
                                            <label
                                                className="form-check-label"
                                                htmlFor={`callResponse_${option.CallResponsesId}`}
                                            >
                                                {option.ResponseName}
                                            </label>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-12 col-sm-6">
                                    <div className="mb-3">
                                        <label htmlFor="DateToBeVisited" className="form-label">
                                            Date To Be Visited
                                        </label>
                                        <input
                                            type="datetime-local"
                                            className="form-control"
                                            id="DateToBeVisited"
                                            name="DateToBeVisited"
                                            placeholder="YYYY-MM-DD HH:MM"
                                            value={formData.DateToBeVisited}
                                            onChange={onChangeHandler}
                                        />
                                    </div>
                                </div>
                                <div className="col-12 col-sm-6">
                                    <div className="mb-3">
                                        <label htmlFor="RequestCallBack" className="form-label">
                                            Request Call Back
                                        </label>
                                        <input
                                            type="datetime-local"
                                            className="form-control"
                                            id="RequestCallBack"
                                            name="RequestCallBack"
                                            placeholder="YYYY-MM-DD HH:MM"
                                            value={formData.RequestCallBack}
                                            onChange={onChangeHandler}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="mb-3">
                                        <label htmlFor="remarks" className="form-label">
                                            Remarks
                                        </label>
                                        <textarea
                                            className="form-control"
                                            id="remarks"
                                            name="callLog"
                                            placeholder="Enter Remarks"
                                            onChange={onChangeHandler}
                                            value={formData.callLog}
                                            rows="4"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 d-flex justify-content-center">
                                    <button
                                        type="submit"
                                        className="btn btn-primary"
                                        disabled={!isFormValid}
                                    >
                                        {isEditing ? "Update" : "Submit"}
                                    </button>
                                    <button
                                        className="btn btn-secondary ms-2"
                                        type="button"
                                        onClick={handleResetForm}
                                    >
                                        Reset
                                    </button>
                                    <button
                                        className="btn btn-danger ms-2"
                                        type="button"
                                        onClick={handleBackToView}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            <div
                className="modal fade"
                id="exLargeModalPurchase"
                tabIndex="-1"
                aria-hidden="true"
                aria-labelledby="exampleModalLabel4"
            >
                <div className="modal-dialog modal-lg modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title" id="exampleModalLabel4">
                                Product Purchase
                            </h4>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>

                        {purchaseProduct ? (
                            <>
                                {/* OHO Card Number Input Card */}
                                {purchaseProduct.IsCombo === true && !cardNumberEntered && (
                                    <div className="card p-3" style={{ minWidth: "400px" }}>
                                        <label
                                            className="form-label"
                                            htmlFor="cardNumber"
                                            style={{ fontSize: "15px" }}
                                        >
                                            Card Number <span className="text-danger"> *</span>
                                        </label>
                                        <input
                                            type="text"
                                            id="cardNumber"
                                            className="form-control"
                                            placeholder="2804 0000 0001"
                                            value={cardNumber}
                                            onChange={handleCardNumberChange}
                                            maxLength={14}
                                        />
                                        {cardNumberError && (
                                            <p className="text-danger">{cardNumberError}</p>
                                        )}
                                        <button
                                            className="btn btn-primary mt-3"
                                            onClick={checkCardNumberExists} // Check if card number exists on click
                                        >
                                            Confirm Card Number
                                        </button>
                                    </div>
                                )}

                                {/* Main Product Details Card */}
                                {(!purchaseProduct.IsCombo || cardNumberEntered) && (
                                    <div className="card p-3 d-flex flex-column align-items-center">
                                        <h5 className="card-header">
                                            <strong>Product Name: </strong>
                                            <span className="text-primary fs-4 fw-bold">
                                                {purchaseProduct.ProductName}
                                            </span>
                                        </h5>
                                        <img
                                            src="https://ohoindia-mous.s3.ap-south-1.amazonaws.com/70ec0ebd-a761-4dc4-acb8-80750653a421.jpg"
                                            alt="QR Code"
                                            className="h-25 w-25 mt-3 mb-3"
                                        />
                                        <p className="fs-5">
                                            Amount to pay:{" "}
                                            <FontAwesomeIcon
                                                icon={faIndianRupeeSign}
                                                className="text-primary"
                                            />{" "}
                                            <span>
                                                {purchaseProduct.InsurancePremiums[0].TotalAmount}
                                            </span>
                                        </p>

                                        <div style={{ minWidth: "400px" }}>
                                            <label
                                                className="form-label"
                                                htmlFor="utrnumber"
                                                style={{ fontSize: "15px" }}
                                            >
                                                UTR Number <span className="text-danger"> *</span>
                                            </label>
                                            <input
                                                type="text"
                                                id="utrnumber"
                                                className="form-control"
                                                placeholder="Enter UTR Number"
                                                value={utrNumber}
                                                onChange={(e) => onChangeUtrNumber(e)}
                                            />
                                            {utrError && (
                                                <p className="text-danger">*Please Enter UTR Number</p>
                                            )}
                                        </div>

                                        <div className="mt-3 d-flex flex-row justify-content-center">
                                            <button
                                                type="submit"
                                                className="btn btn-primary me-sm-3 me-1"
                                                onClick={(e) => submitUtrForm(e)}
                                                style={{ minWidth: "100px" }}
                                                disabled={utrSubmitLoad}
                                            >
                                                {utrSubmitLoad ? (
                                                    <div class="spinner-border text-white" role="status">
                                                        <span class="sr-only">Loading...</span>
                                                    </div>
                                                ) : (
                                                    "Submit"
                                                )}
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-label-secondary"
                                                onClick={() => setPurchaseProduct()}
                                            >
                                                Cancel
                                            </button>
                                        </div>

                                        {paymentSuccessMsg && (
                                            <p className="text-success mt-3">
                                                Successfully purchased product
                                            </p>
                                        )}
                                        {memberPrdAddFail && memberPrdAddFail.length > 0 && (
                                            <p className="text-danger mt-3">{memberPrdAddFail}</p>
                                        )}
                                        {paymentFailureError && paymentFailureError.length > 0 && (
                                            <p className="text-danger mt-3">{paymentFailureError}</p>
                                        )}
                                        {updatePaymentForProductError &&
                                            updatePaymentForProductError.length > 0 && (
                                                <p className="text-danger mt-3">
                                                    {updatePaymentForProductError}
                                                </p>
                                            )}
                                        {cardAddError && cardAddError.length > 0 && (
                                            <p className="text-danger mt-3">{cardAddError}</p>
                                        )}
                                    </div>
                                )}
                            </>
                        ) : availableProducts && availableProducts.length > 0 ? (
                            <div className="container-fluid">
                                <div className="row">
                                    {availableProducts.map((product) => (
                                        <div
                                            key={product.ProductsId}
                                            className="card d-flex flex-column col-md-5 p-3 mt-2 mb-2 me-3"
                                        >
                                            <div className="d-flex flex-row align-items-center">
                                                <i
                                                    className="fa-solid fa-circle-check me-2"
                                                    style={{ color: "#349bc7" }}
                                                ></i>
                                                <h5 className="mb-1 text-dark">
                                                    {product.ProductName}
                                                </h5>
                                            </div>

                                            <div className="d-flex flex-row align-items-center">
                                                <h6>Amount: </h6>
                                                <p className="ms-1">
                                                    <i
                                                        className="fa-solid fa-indian-rupee-sign"
                                                        style={{ color: "#349bc7" }}
                                                    ></i>{" "}
                                                    {product.InsurancePremiums[0].TotalAmount}
                                                </p>
                                            </div>
                                            <button
                                                className="btn btn-primary align-self-end"
                                                onClick={() => setPurchaseProduct(product)}
                                            >
                                                Purchase
                                            </button>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ) : (
                            <div>
                                <h4 className="text-danger fw-semibold text-center">
                                    No Products Available
                                </h4>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            <div
                className="modal fade"
                id="exLargeModal"
                tabIndex="-1"
                aria-hidden="true"
                aria-labelledby="exampleModalLabel4"
            >
                <div className="modal-dialog modal-lg modal-dialog-centered">
                    {selectedPolicy && (
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title" id="exampleModalLabel4">
                                    Upload Document for {selectedPolicy.PoliciesProductName}
                                </h4>
                                <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                    onClick={() => handleCloseModal()}
                                ></button>
                            </div>

                            <form
                                className="form-group custom-form p-3"
                                onSubmit={handleFileSubmit}
                            >
                                <div className="row g-2">
                                    <div className="col-12 col-md-6">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter COI Number"
                                            value={PolicyCOINumber}
                                            onChange={(e) => setPolicyCOINumber(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <input
                                            type="file"
                                            className="form-control"
                                            required
                                            onChange={(e) => handleUploadChange(e)}
                                        />
                                    </div>
                                </div>
                                <button
                                    type="submit"
                                    className="btn btn-success mt-2"
                                    disabled={!file || !PolicyCOINumber}
                                >
                                    {policyUploadLoad ? (
                                        <div className="spinner-border text-white" role="status">
                                            <span className="sr-only">Loading...</span>
                                        </div>
                                    ) : (
                                        "UPLOAD"
                                    )}
                                </button>
                            </form>
                        </div>
                    )}
                </div>
            </div>

            {/* <div
        style={{
          position: "sticky",
          bottom: "10px",
          display: "flex",
          justifyContent: "flex-end",
          width: "100%",
        }}
      >
        <button
          className="btn btn-dark"
          data-bs-toggle="modal"
          data-bs-target="#exLargeModalPurchase"
          onClick={() => setPurchaseProduct()}
        >
          Purchase
        </button>
      </div> */}

            <TableContainer component={Paper}>
                <ConfirmationDialogDelete
                    open={confirmationOpen}
                    title={confirmationData.title}
                    message={confirmationData.message}
                    onConfirm={confirmationData.onConfirm}
                    onCancel={() => setConfirmationOpen(false)}
                />
                <Snackbar
                    open={snackbarOpen}
                    autoHideDuration={6000}
                    onClose={handleSnackbarClose}
                    anchorOrigin={{ vertical: "top", horizontal: "right" }}
                >
                    <Alert onClose={handleSnackbarClose} severity="success">
                        {snackbarMessage}
                    </Alert>
                </Snackbar>
            </TableContainer>
        </>
    );
}
